import React from "react";
import {
  Platform,
  View,
  TextInput,
  TouchableOpacity,
  Dimensions,
  StyleSheet,
  FlatList,
  Image,
  NativeModules,
  ScrollView,
  Button,
  Keyboard,
  Linking,
  ActivityIndicator,
  Alert,
  Pressable,
  ImageBackground,
} from "react-native";
import Text from "../components/Text";
import alert from './alert'
import AsyncStorage from "@react-native-async-storage/async-storage";
import { WebView } from "react-native-webview";
import Modal from "react-native-modalbox";
import Color, { Red, Transparent } from "react-native-material-color";
import Toast from 'react-native-toast-message';
import moment from "moment";
import { STRINGS } from "./Strings";
import * as ServerOperations from "./ServerOperations";
import * as Constants from "./Constants";
import * as Styles from "./Styles";
import * as SharedUtils from "./SharedUtils";
import * as types from "../types";
import * as Localization from "expo-localization";
import Header from "../components/Header";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import MapView from "../map";
import { Marker } from "../mapMarker";
import { Picker } from "react-native-web";
import * as AppStyles from "../utils/appStyles";
import * as Animatable from "react-native-animatable";
const arrowLeftIcon = require("../assets/arrow-left.png");
const faceBookIcon = require("../images/facebook.png");
const instagramIcon = require("../images/instagram.png");
const linkedinIcon = require("../images/linkedin.png");
const faceBookHoveredIcon = require("../images/facebook2.png");
const instagramHoveredIcon = require("../images/instagram2.png");
const linkedinHoveredIcon = require("../images/linkedin2.png");
const drawerIconImgLight = require("../../assets/logo.png");
import { v4 as uuidv4 } from 'uuid';
const otherIcon = require("../images/Shop/otherFooter.png");
const imgSearchIcon = require("../images/Shop/searchIcon.png");
const imgOrderNow = require("../images/Shop/orderNow.png");
const imgHomeGreyFooter = require("../images/Shop/homeGreayFooter.png");
const SearchCloseIcon = require("../images/Commons/closeIcon.png");
const myorders = require("../images/Commons/myorders.png");
const plus = require("../images/Shop/plus.png");
const minus = require("../images/Shop/minus.png");
const circlePlus = require("../images/Shop/circlePlus.png");
const imgGreenVector = require("../images/Shop/AddVector.png");
const giftIcon = require("../images/orderNow/gift.png");
const SOAimg = require("../images/ClientHomePage/SOA.png");
const IRimg = require("../images/ClientHomePage/IR.png");
const notificationImg = require("../images/orderNow/notifications.png");
const imgProfile = require("../images/Header/Profile.png");
const cartIcon = require("../images/home/cartIcon.png");
const cameraImg = require("../images/CheckOut/Camera.png");
const notifyImg = require("../images/noitfy.png");
// import AsyncStorage from '@react-native-async-storage/async-storage';

let isDetailsOpen = false;

// QR Code Scanner function
export const handleQRCodeScan = async (self) => {
  try {
    // For React Native, we would typically use expo-barcode-scanner or react-native-camera
    // Since this appears to be a React Native Web app, we'll implement a web-based solution

    if (Platform.OS === 'web') {
      // Check if camera is available, otherwise show manual input
      if (typeof navigator !== 'undefined' && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Web implementation using WebRTC and jsQR
        await scanQRCodeWeb(self);
      } else {
        // Fallback to manual input
        await showManualQRInput(self);
      }
    } else {
      // Native implementation using expo-barcode-scanner
      await scanQRCodeNative(self);
    }
  } catch (error) {
    console.error('QR Code scanning error:', error);
    // Show manual input as fallback
    await showManualQRInput(self);
  }
};

// Web implementation for QR/Barcode scanning
const scanQRCodeWeb = async (self) => {
  try {
    // Check if we're in a browser environment and camera APIs are available
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
      throw new Error('Not in browser environment');
    }

    // Check for HTTPS or localhost (required for camera access)
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      throw new Error('Camera access requires HTTPS or localhost');
    }

    // Check if mediaDevices API is available
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error('Camera API not supported');
    }

    // Dynamically import ZXing for comprehensive 2D barcode support with performance optimizations
    const [ZXing] = await Promise.all([
      import('@zxing/library').then(module => {
        console.log('ZXing library loaded successfully');
        return module;
      })
    ]);

    // Use ZXing for 2D barcode detection
    const codeReader = new ZXing.BrowserMultiFormatReader();

    // Create a modal or overlay for the camera with optimized settings for faster detection
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: 'environment', // Use back camera if available
        width: { ideal: 1280, min: 640 }, // Higher resolution for better barcode clarity
        height: { ideal: 720, min: 480 },
        frameRate: { ideal: 30, min: 15 }, // Higher frame rate for faster detection
        focusMode: 'continuous', // Continuous autofocus
        exposureMode: 'continuous' // Auto exposure for better barcode contrast
      }
    });

    // Create video element
    const video = document.createElement('video');
    video.srcObject = stream;
    video.autoplay = true;
    video.playsInline = true;
    video.muted = true;

    // Create canvas for capturing frames
    const canvas = document.createElement('canvas');

    // Create overlay container
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.8);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
    `;

    // Create scanning instruction text
    const instructionText = document.createElement('div');
    instructionText.textContent = 'Point camera at barcode';
    instructionText.style.cssText = `
      color: white;
      font-size: 18px;
      margin-bottom: 20px;
      text-align: center;
    `;

    // Style video for optimal scanning performance
    video.style.cssText = `
      width: 90%;
      max-width: 500px;
      height: auto;
      border: 2px solid #fff;
      border-radius: 8px;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: optimize-contrast;
    `;

    // Add scanning guide overlay for better targeting
    const scanGuide = document.createElement('div');
    scanGuide.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 250px;
      height: 250px;
      border: 3px solid #00ff00;
      border-radius: 12px;
      pointer-events: none;
      z-index: 1;
    `;

    // Add scanning tips
    const tipsText = document.createElement('div');
    tipsText.innerHTML = `
      <div style="color: #00ff00; font-size: 14px; margin-top: 10px;">
        • Hold device steady<br>
        • Ensure good lighting<br>
        • Center barcode in green box
      </div>
    `;
    tipsText.style.cssText = `
      text-align: center;
      margin-top: 10px;
    `;

    // Add close button
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close Scanner';
    closeButton.style.cssText = `
      margin-top: 20px;
      padding: 10px 20px;
      background: #fff;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
    `;

    overlay.appendChild(instructionText);

    // Create video container with scan guide
    const videoContainer = document.createElement('div');
    videoContainer.style.cssText = `
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    `;

    videoContainer.appendChild(video);
    videoContainer.appendChild(scanGuide);
    overlay.appendChild(videoContainer);
    overlay.appendChild(tipsText);
    overlay.appendChild(closeButton);
    document.body.appendChild(overlay);

    let scanningInterval;
    let isScanning = true;
    let zxingInitialized = false;

    // Initialize ZXing for 2D barcode scanning with performance optimizations
    const initZXing = async () => {
      if (zxingInitialized) return;

      console.log('Attempting to initialize ZXing for high-speed 2D barcode detection...');

      try {
        // Check if ZXing is available
        if (!codeReader) {
          console.warn('ZXing code reader is not available');
          return;
        }

        // Configure ZXing with performance hints
        const hints = new Map();
        hints.set(ZXing.DecodeHintType.TRY_HARDER, false); // Disable try harder for speed
        hints.set(ZXing.DecodeHintType.POSSIBLE_FORMATS, [
          ZXing.BarcodeFormat.DATA_MATRIX,
          ZXing.BarcodeFormat.PDF_417,
          ZXing.BarcodeFormat.QR_CODE,
          ZXing.BarcodeFormat.AZTEC,
          ZXing.BarcodeFormat.MAXICODE
        ]); // Limit to 2D formats only
        hints.set(ZXing.DecodeHintType.PURE_BARCODE, false); // Allow impure barcodes

        codeReader.hints = hints;

        console.log('ZXing code reader initialized with performance optimizations');
        zxingInitialized = true;

        // Start continuous 2D barcode scanning with faster detection
        try {
          await codeReader.decodeFromVideoDevice(null, video, (result, error) => {
            if (result && isScanning) {
              console.log('2D Barcode detected by ZXing:', result.getText());

              // 2D Barcode detected!
              isScanning = false;
              clearInterval(scanningInterval);
              codeReader.reset(); // Stop ZXing scanning

              handleCodeDetected(result.getText(), `2D Barcode (${result.getBarcodeFormat()})`);
            }

            // Reduce error logging for performance (only log critical errors)
            if (error && error.name !== 'NotFoundException' && error.name !== 'ChecksumException') {
              console.warn('ZXing scanning error:', error);
            }
          });

          console.log('ZXing high-speed 2D barcode scanning started');
          // instructionText.textContent = 'Point camera at barcode (Optimized for fast detection)';

        } catch (startError) {
          console.warn('Failed to start ZXing scanning:', startError);
          instructionText.textContent = '2D barcode scanner initialization failed';
          instructionText.style.color = '#ff9800';
        }

      } catch (error) {
        console.warn('Failed to initialize ZXing:', error);
        instructionText.textContent = '2D barcode scanner not available';
        instructionText.style.color = '#ff9800';
      }
    };

    // Handle detected code (QR or Barcode)
    const handleCodeDetected = async (codeData, codeType) => {
      self.search(codeData);

      // Show success message
      instructionText.textContent = `${codeType} Found: ${codeData}`;
      instructionText.style.color = '#4CAF50';

      // Clean up after 2 seconds
      setTimeout(() => {
        stream.getTracks().forEach(track => track.stop());
        if (document.body.contains(overlay)) {
          document.body.removeChild(overlay);
        }
      }, 0);
    };

    // Function for fallback scanning (if needed)

    // Start scanning when video is ready with performance optimizations
    video.onloadedmetadata = async () => {
      console.log('Video loaded, initializing high-speed ZXing 2D barcode scanner...');

      // Optimize video element for better performance
      video.setAttribute('playsinline', 'true');
      video.setAttribute('webkit-playsinline', 'true');

      // Initialize ZXing for fast 2D barcode detection
      await initZXing();
    };

    // Close button functionality
    closeButton.onclick = () => {
      isScanning = false;
      clearInterval(scanningInterval);
      if (zxingInitialized && codeReader) {
        codeReader.reset(); // Stop ZXing scanning
        zxingInitialized = false;
      }
      stream.getTracks().forEach(track => track.stop());
      if (document.body.contains(overlay)) {
        document.body.removeChild(overlay);
      }
    };

    // Clean up if overlay is removed externally
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (!document.body.contains(overlay)) {
            isScanning = false;
            clearInterval(scanningInterval);
            if (zxingInitialized && codeReader) {
              codeReader.reset(); // Stop ZXing scanning
              zxingInitialized = false;
            }
            observer.disconnect();
          }
        }
      });
    });
    observer.observe(document.body, { childList: true });

  } catch (error) {
    console.error('Web QR scanning error:', error);

    // Provide specific error messages based on the error type
    if (error.message === 'Not in browser environment') {
      Alert.alert('Not Supported', 'QR scanning is not available in this environment.');
    } else if (error.message === 'Camera access requires HTTPS or localhost') {
      Alert.alert('HTTPS Required', 'Camera access requires a secure connection (HTTPS) or localhost. Please ensure you are using HTTPS.');
    } else if (error.message === 'Camera API not supported') {
      Alert.alert('Not Supported', 'Your browser does not support camera access. Please use a modern browser like Chrome, Firefox, or Safari.');
    } else if (error.name === 'NotAllowedError') {
      Alert.alert('Permission Denied', 'Camera permission was denied. Please allow camera access to scan QR codes.');
    } else if (error.name === 'NotFoundError') {
      Alert.alert('No Camera Found', 'No camera device was found on this device.');
    } else if (error.name === 'NotSupportedError') {
      Alert.alert('Not Supported', 'Camera access is not supported on this device or browser.');
    } else if (error.name === 'NotReadableError') {
      Alert.alert('Camera Busy', 'Camera is already in use by another application.');
    } else {
      Alert.alert('Camera Error', `Unable to access camera: ${error.message || 'Unknown error'}`);
    }
  }
};

// Native implementation for QR code scanning
const scanQRCodeNative = async (self) => {
  try {
    // Import expo-barcode-scanner dynamically
    const { BarCodeScanner } = await import('expo-barcode-scanner');

    // Request camera permissions
    const { status } = await BarCodeScanner.requestPermissionsAsync();
    if (status !== 'granted') {
      Alert.alert('Permission Required', 'Camera permission is required to scan QR codes');
      return;
    }

    // Set scanning state
    self.setState({ showQRScanner: true });

    // Note: You would need to implement the actual scanner component in your screen
    // This is just setting up the state to show the scanner

  } catch (error) {
    console.error('Native QR scanning error:', error);
    Alert.alert('Scanner Error', 'QR code scanner is not available');
  }
};

// Fallback manual QR input when camera is not available
const showManualQRInput = async (self) => {
  try {
    // Create overlay container
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.8);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
    `;

    // Create title text
    const titleText = document.createElement('div');
    titleText.textContent = 'Enter 2D Barcode / Search Text';
    titleText.style.cssText = `
      color: white;
      font-size: 20px;
      margin-bottom: 20px;
      text-align: center;
      font-weight: bold;
    `;

    // Create input field
    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = 'Enter 2D barcode data or search text...';
    input.style.cssText = `
      width: 90%;
      max-width: 400px;
      padding: 15px;
      font-size: 16px;
      border: 2px solid #fff;
      border-radius: 8px;
      margin-bottom: 20px;
      text-align: center;
      outline: none;
    `;

    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = `
      display: flex;
      gap: 15px;
    `;

    // Create search button
    const searchButton = document.createElement('button');
    searchButton.textContent = 'Search';
    searchButton.style.cssText = `
      padding: 10px 20px;
      background: #4CAF50;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
    `;

    // Create close button
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Cancel';
    closeButton.style.cssText = `
      padding: 10px 20px;
      background: #f44336;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
    `;

    buttonContainer.appendChild(searchButton);
    buttonContainer.appendChild(closeButton);

    overlay.appendChild(titleText);
    overlay.appendChild(input);
    overlay.appendChild(buttonContainer);
    document.body.appendChild(overlay);

    // Focus on input
    setTimeout(() => input.focus(), 100);

    // Search functionality
    const performSearch = () => {
      const searchData = input.value.trim();
      if (searchData) {
        // Update search text with input data
        self.search(searchData);

        // Trigger search filtering
        const backup = self.state.productsBackup || self.state.products;
        const filtered = backup.filter(item => {
          const nameMatch = item.NAME && item.NAME.toLowerCase().includes(searchData.toLowerCase());
          const barcodeMatch = item.BARCODE && item.BARCODE.toLowerCase().includes(searchData.toLowerCase());
          const priceMatch = item.PUBLIC_PRICE && item.PUBLIC_PRICE.includes(searchData);
          const categMatch = (item.CATEG_EN_NAME && item.CATEG_EN_NAME.toLowerCase().includes(searchData.toLowerCase())) || (item.CATEG_AR_NAME && item.CATEG_AR_NAME.toLowerCase().includes(searchData.toLowerCase()));
          const brandMatch = (item.BRAND_EN_NAME && item.BRAND_EN_NAME.toLowerCase().includes(searchData.toLowerCase())) || (item.BRAND_AR_NAME && item.BRAND_AR_NAME.toLowerCase().includes(searchData.toLowerCase()));
          return nameMatch || barcodeMatch || priceMatch || categMatch || brandMatch;
        });
        self.setState({ products: filtered, isSearch: true });
      }

      // Clean up
      if (document.body.contains(overlay)) {
        document.body.removeChild(overlay);
      }
    };

    // Event listeners
    searchButton.onclick = performSearch;
    input.onkeypress = (e) => {
      if (e.key === 'Enter') {
        performSearch();
      }
    };

    closeButton.onclick = () => {
      if (document.body.contains(overlay)) {
        document.body.removeChild(overlay);
      }
    };

  } catch (error) {
    console.error('Manual QR input error:', error);
    Alert.alert('Input Error', 'Unable to show manual input dialog');
  }
};

export const setDetailsOpen = (value) => {
  isDetailsOpen = value;
};

export const getDetailsOpen = () => {
  return isDetailsOpen;
};


export const getDeviceID = SharedUtils.getDeviceID;

export const language = SharedUtils.language;


// Icons
let width = Math.max(Dimensions.get("window").width, Constants.MIN_WIDTH);
const height = Dimensions.get("window").height;

export const getWidth = () => {
  // width = Math.max(Constants.MIN_WIDTH, width);
  // width = Math.min(Constants.MAX_WIDTH, width);
  return Constants.MAX_WIDTH;
}

export const getDesktopHeight = () => {
  // let width = Dimensions.get("window").width;
  let height = Dimensions.get("window").height;
  // let scale = Constants.MAX_WIDTH / width;
  // if (scale < 1) scale = 1;
  let scale = 1;
  return height * scale - 15;
}

export const getDesktopWidth = () => {
  let width = Dimensions.get("window").width;
  // let scale = Constants.MAX_WIDTH / Dimensions.get("window").width;
  // console.log('getDesktopWidth: ' + width, "scale: " + scale, " MAX_WIDTH: " + Dimensions.get("window").width);
  // if (scale < 1) scale = 1;
  let scale = getMenuScale();
  return width - Constants.SIDEBAR_WIDTH * scale;
}

export const isMobile = () => {
  width = Dimensions.get("window").width;
  return width <= Constants.MOBILE_WIDTH;
}

export const onHeaderScroll = (e, self) => {
  const prevScrollPos = self.state.prevScrollPos ? self.state.prevScrollPos : 0;
  const newScrollPos = e.nativeEvent.contentOffset.y;
  self.setState({
    prevScrollPos: newScrollPos,
    hideHeader: prevScrollPos < newScrollPos,
    hideScrollTopButton: newScrollPos < 400
  });
}

export const getBrowser = () => {
  var OSName = "Unknown";
  if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) OSName = "Windows 10";
  if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1) OSName = "Windows 8.1";
  if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName = "Windows 8";
  if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName = "Windows 7";
  if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName = "Windows Vista";
  if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName = "Windows XP";
  if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName = "Windows 2000";
  if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
  if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
  if (window.navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
  if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS";
  if (window.navigator.userAgent.indexOf("iPhone") != -1) OSName = "iOS";
  return OSName;
}

export const loadFonts = (self, scale = true, center = true, maxZoom = 1) => {
  if (!window.visualViewport) {
    // Setup window navigation functions for React Native mobile
    if (!window.history) {
      window.history = {
        back: () => {
          if (self.props && self.props.navigation && self.props.navigation.goBack) {
            self.props.navigation.goBack();
          }
        },
        forward: () => {
          // Not typically used in mobile apps
          console.log('history.forward not implemented on mobile');
        },
        go: (n) => {
          if (n === -1 && self.props && self.props.navigation && self.props.navigation.goBack) {
            self.props.navigation.goBack();
          }
        },
        pushState: (state, title, url) => {
          // Handle pushState for React Native navigation
          if (url && self.props && self.props.navigation && self.props.navigation.navigate) {
            // Extract route from URL
            const route = url.replace(/^\//, '').replace(/^\.\//, '');
            if (route) {
              self.props.navigation.navigate(route, state);
            }
          }
        },
        replaceState: (state, title, url) => {
          // Similar to pushState but replace current route
          if (url && self.props && self.props.navigation && self.props.navigation.replace) {
            const route = url.replace(/^\//, '').replace(/^\.\//, '');
            if (route) {
              self.props.navigation.replace(route, state);
            }
          } else if (url && self.props && self.props.navigation && self.props.navigation.navigate) {
            // Fallback to navigate if replace not available
            const route = url.replace(/^\//, '').replace(/^\.\//, '');
            if (route) {
              self.props.navigation.navigate(route, state);
            }
          }
        },
        state: null
      };
    }

    // Override window.location for React Native navigation
    const originalLocation = window.location || {};

    // Create a custom location object with pathname support
    const customLocation = {
      ...originalLocation,
      pathname: self.props?.navigation?.state?.routeName
        ? `/${self.props.navigation.state.routeName}`
        : '/',
      href: originalLocation.href || '',
      origin: originalLocation.origin || '',
      search: originalLocation.search || '',
      hash: originalLocation.hash || ''
    };

    Object.defineProperty(window, 'location', {
      get: () => customLocation,
      set: (value) => {
        if (typeof value === 'string') {
          // Extract route name from path
          const route = value.replace('./', '').replace('/', '');
          if (self.props && self.props.navigation && self.props.navigation.navigate) {
            // Navigate to the route
            self.props.navigation.navigate(route);
            // Update pathname
            customLocation.pathname = `/${route}`;
          }
        }
      },
      configurable: true
    });
    return [
      <Modal
        ref={(el) => (self.loadingModal = el)}
        position={"top"}
        animationDuration={0}
        backdrop={true}
        backdropColor="white"
        backdropOpacity={0.8}
        style={{
          height: height + 130,
          padding: 12,
          marginTop: -100,
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          flexDirection: 'row',
          backgroundColor: Transparent,
          zIndex: 99999999
        }}
        coverScreen={true}
        entry="bottom"
        swipeToClose={false}
        backdropPressToClose={false}
      >
        <ActivityIndicator size="large" color={Styles.appColor1} />
        {/* <Text style={{
      paddingHorizontal: 15, color: "#6b3529",
      fontFamily: self.props.fontFamily,
      fontWeight: self.props.fontWeight,
      fontSize: self.props.fontSize + 2
    }}>{STRINGS.please_wait}</Text> */}

      </Modal>];
  }
  const maxWidth = Constants.MAX_WIDTH;
  width = Dimensions.get("window").width;
  const isMobile = Dimensions.get("window").width < Constants.MOBILE_WIDTH;
  // const isMobile = Dimensions.get("window").width < Constants.MOBILE_WIDTH && window.location.pathname.indexOf("/home") > -1;
  let zoom = (Dimensions.get("window").width > maxWidth && false ? maxWidth : Dimensions.get("window").width) / maxWidth
  if (zoom > maxZoom) zoom = maxZoom;
  if (!scale) zoom = 1;
  const xZoom = zoom;
  let zoomLevel = parseInt(window.visualViewport.scale * 100);
  if (!self.zoomLevel) {
    setTimeout(() => {
      self.zoomLevel = zoomLevel;
    }, 2000);
  }
  const browser = getBrowser();
  if (self.zoomLevel && !(browser == "Mac/iOS" || browser == 'iPhone')) {
    zoom *= zoomLevel / self.zoomLevel;
  };
  let zoomStr = `zoom:${zoom}`;
  let metaStr = `<meta name="viewport" content=",minimum-scale=0.3,maximum-scale=2.0" />`
  if ((browser == "Mac/iOS") && xZoom < 0.3) zoomStr = "";
  if (browser == 'iOS') {
    zoomStr = "";
    metaStr = `<meta name="viewport" content="minimum-scale=0.3,maximum-scale=2.0" />`
  }
  let minWidthStr = `min-width: ${Constants.MIN_WIDTH}px;`
  if (isMobile || !scale) {
    // metaStr = `<meta name="viewport" content="width=${width},minimum-scale=1,maximum-scale=3.0" />`;
    metaStr = ``;
    zoomStr = "";
    minWidthStr = "";
  }
  // minWidthStr = "";
  // <div style="position:absolute;top:100px;left:100px;z-index:9999"> **** ${zoomStr}  ***  ${zoom} ***  ${xZoom}</div>
  return ([<div dangerouslySetInnerHTML={{
    __html: `
    
  ${metaStr}
  <style> 
    body {
     ${minWidthStr}
     ${zoomStr};
     overflow-y:hidden;
  }


    #root{
      ${center ? `margin-left:auto;margin-right:auto;` : ''}
      ${scale && center ? `max-width: ${Constants.MAX_WIDTH}px;` : ''}
    }

    @font-face {
      font-family: Satoshi-Regular;
      font-weight: normal;
      font-style: normal;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/Satoshi-Regular.ttf') format('truetype');
    }

    @font-face {
      font-family: Satoshi-Regular;
      font-weight: 400;
      font-style: normal;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/Satoshi-Regular.ttf') format('truetype');
    }

    @font-face {
      font-family: Satoshi-Medium;
      font-weight: 500;
      font-style: normal;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/Satoshi-Medium.ttf') format('truetype');
    }
    
    @font-face {
      font-family: Satoshi-Bold;
      font-weight: 700;
      font-style: normal;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/Satoshi-Bold.ttf') format('truetype');
    }

    @font-face {
      font-family: Satoshi-Bold;
      font-weight: bold;
      font-style: normal;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/Satoshi-Bold.ttf') format('truetype');
    }


    @font-face {
      font-family: "PP Neue Montreal";
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/ppneuemontreal-book.otf');
    }

    @font-face {
      font-family: "PP Neue Montreal";
      font-weight: 700;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/ppneuemontreal-bold.otf');
    }
    

    @font-face {
      font-family: PTSans;
      src: url('https://sales.jdsco.net:8444/pick/faces/attachments/fonts/PTSans-Regular.ttf');
    }

    

    video{
      position:relative !important
    }

    /* width */
    ::-webkit-scrollbar {
      width: 5px;
      height: 7px;
    }
  

    /* Track */
    ::-webkit-scrollbar-track {
      background: #eeee; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #3B627F; 
      border-radius:7px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #3B627F; 
    }
    </style>
    <input type="file" id="select" style="display:none"  accept="image/png, image/jpeg,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"/>
    `

  }} />,

  <Modal
    ref={(el) => (self.loadingModal = el)}
    position={"top"}
    animationDuration={0}
    backdrop={true}
    backdropColor="white"
    backdropOpacity={0.8}
    style={{
      height: -1,
      padding: 12,
      marginTop: -100,
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      flexDirection: 'row',
      backgroundColor: Transparent,
      zIndex: 99999999
    }}
    coverScreen={true}
    entry="bottom"
    swipeToClose={false}
    backdropPressToClose={false}
  >
    <ActivityIndicator size="large" color={Styles.appColor1} />
    {/* <Text style={{
      paddingHorizontal: 15, color: "#6b3529",
      fontFamily: self.props.fontFamily,
      fontWeight: self.props.fontWeight,
      fontSize: self.props.fontSize + 2
    }}>{STRINGS.please_wait}</Text> */}

  </Modal>
  ]
  );
}


export const renderInvoiceDetails = async () => {
}




const renderDeliveryTimes = (self) => {
  const resp = [];
  let pos = 0;
  let respPos = 0;
  resp.push([]);
  let tmpWidth = width / 5;
  if (tmpWidth < 5) {
    tmpWidth = 320;
  }
  self.props.deliveryTimes.map((time) => {
    if (tmpWidth <= 320 && pos == 5) {
      respPos += 1;
      resp.push([]);
    }
    let isSelected = false;
    if (time.value == self.props.time) isSelected = true;
    if (time.value != "") {
      if (!isSelected) {
        resp[respPos].push(
          <TouchableOpacity
            style={{
              padding: 10,
              paddingVertical: 15,
              marginRight: 15,
              backgroundColor: "#f3f3f3",
              width: 65,
              alignContent: "center",
              justifyContent: "center"
            }}
            onPress={() => self.props.updateState({ time: time.value })}
          >
            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 4,
                color: "#6b3529",
                alignSelf: "center",
              }}
            >
              {time.value.replace(/ /g, '').replace(/-/g, '\n').replace(/:/g, ' : ')}
            </Text>
          </TouchableOpacity>
        );
      } else {
        resp[respPos].push(
          <TouchableOpacity
            style={{
              padding: 10,
              paddingVertical: 15,
              marginRight: 15,
              width: 65,
              alignContent: "center",
              justifyContent: "center",
              backgroundColor: "#f3f3f3",
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: "#6b3529",
            }}
            onPress={() => self.props.updateState({ time: time.value })}
          >
            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 4,
                color: "#6b3529",
                alignSelf: "center",
              }}
            >
              {time.value.replace(/ /g, '').replace(/-/g, '\n').replace(/:/g, ' : ')}
            </Text>
          </TouchableOpacity>
        );
      }
    }
    pos++;
  });
  for (let i = 0; i < resp.length; i++) {
    resp[i] = <View style={{ flexDirection: "row", marginTop: 10 }}>{resp[i]}</View>
  }
  return resp;
};

export const photoModalWidthDims = () => {
  let width = Dimensions.get("window").width * 2 - 50;
  let height =
    Dimensions.get("window").height < 410
      ? Dimensions.get("window").height - 80
      : 170;
  // height = 400;
  // width = 700;
  return { width, height };
};
// import Text from '../components/Text';
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// const loaderHandler = require('../components/react-native-busy-indicator/LoaderHandler');


export const getBasketItems = async () => {
  try {
    let itemsInBasket = await getFromAS(Constants.ITEMS_IN_BASKET);
    if (itemsInBasket == null || itemsInBasket == undefined || itemsInBasket == 'undefined') {
      itemsInBasket = '[]';
    }
    return JSON.parse(itemsInBasket);
  } catch (error) {
    console.log(error);
  }
  return [];
}

export const getFromAS = SharedUtils.getFromAS;

export const saveToAS = SharedUtils.saveToAS;

export const multiSaveToAS = async (pairs) => {
  try {
    await AsyncStorage.multiSet(pairs);
  } catch (error) {
    console.log(error);
  }
};

export const removeFromAS = async (key) => {
  try {
    return await AsyncStorage.removeItem(key);
  } catch (error) {
    console.log(error);
  }
};

export const okAlert = (title, msg, cancelable = true, fnToPerform = null) => {
  alert(
    title,
    msg,
    [
      {
        text: STRINGS.ok,
        style: "cancel",
        onPress: fnToPerform,
      },
    ],
    { cancelable }
  );
};

export const okMsgAlert = (msg, cancelable = true, fnToPerform = null) => {
  okAlert(
    '',
    msg + " ",
    cancelable,
    fnToPerform
  );
};

export const confirmAlert = (title, msg, yesFn, self) => {
  // alert('confirm alert > ' + title + '\n' + msg);
  // yesFn(self);
  alert(title, msg, [
    {
      text: STRINGS.cancel,
      style: "cancel",
    },
    {
      text: STRINGS.yes,
      onPress: () => yesFn(self),
    },
  ]);
};

export const confirmLanguageAlert = (title, msg, yesFn) => {
  alert(title, msg, [
    {
      text: STRINGS.cancel_ol,
      style: "cancel",
    },
    {
      text: STRINGS.yes_ol,
      onPress: yesFn,
    },
  ]);
};

export const toast = (value, type = 'info') => {
  console.log(value);
  Toast.show({
    type,
    text1: value,
    // text2: 'This is some something 👋'
  });
  // Toast.show(value, {
  //   duration: duration,
  //   position: top ? Toast.positions.TOP + 72 : -42,
  //   shadow: true,
  //   animation: true,
  //   delay: 0,
  // });
};

export const renderErrorView = (retryFn) => (
  <View
    style={{
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <TouchableOpacity onPress={retryFn}>
      <Text
        style={{ fontSize: 22, color: Color.GREY[900], textAlign: "center" }}
      >
        {STRINGS.connection_error}
      </Text>
      <Text
        style={{ fontSize: 22, color: Color.BLUE[500], textAlign: "center" }}
      >
        {STRINGS.try_again}
      </Text>
    </TouchableOpacity>
  </View>
);

export const getNumColumns = () => {
  let xwidth = Dimensions.get("window").width;
  if (!isMobile()) {
    xwidth = xwidth - Constants.SIDEBAR_WIDTH;
  }
  if (xwidth > 1450) return 6;
  if (xwidth > 1150) return 5;
  if (xwidth > 820) return 4;
  if (xwidth > 550) return 3;
  if (xwidth > 400) return 2;
  return 2;
};

export const renderEmptyView = (msg) => (
  <View
    pointerEvents="none"
    style={{
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Text style={{ fontSize: 22, color: Color.GREY[900], textAlign: "center" }}>
      {msg}
    </Text>
  </View>
);

export const fillAllFields = () => {
  okAlert(
    Platform.OS === "android" ? "" : STRINGS.fill_all_fields,
    Platform.OS === "android" ? STRINGS.fill_all_fields : ""
  );
};

export const isIphoneX = () => {
  const dimen = Dimensions.get("window");
  return (
    Platform.OS === "ios" &&
    !Platform.isPad &&
    !Platform.isTVOS &&
    (dimen.height === 812 ||
      dimen.width === 812 ||
      dimen.height === 896 ||
      dimen.width === 896)
  );
};

export const isArabic = () => STRINGS.curLanguage.startsWith("ar");

export const getItemFullName = (item) => {
  try {
    const name = isArabic() ? item.ArName : item.EnName;
    return name;
  } catch (err) {
    return "";
  }
};



export const getItemName = (item) => {
  try {
    const name = isArabic() ? item.ArName : item.EnName;
    const index = name.lastIndexOf(" ");
    return name.substr(0, index);
  } catch (err) {
    return "";
  }
};

export const getItemUnit = (item) => {
  const name = isArabic() ? item.ArName : item.EnName;
  const index = name.lastIndexOf(" ");
  return name.substr(index + 1);
};

export const getGenderName = (value) =>
  value === "1" ? STRINGS.female : STRINGS.male;
export const getMaritalStatus = (value) =>
  value === "1" ? STRINGS.married : STRINGS.single;

export const saveUserInfo = async (user) => {
  //ahmad.alsaleh@instant-rep.com
  const pairs = [];
  pairs.push([Constants.email, user.EMAIL]);
  pairs.push([Constants.username, user.USERNAME]);
  pairs.push([Constants.password, user.PASSWORD]);
  pairs.push([Constants.firstName, user.FIRSTNAME]);
  pairs.push([Constants.lastName, user.LASTNAME]);
  pairs.push([Constants.birthdate, user.BIRTHDATE]);
  pairs.push([Constants.gender, user.GENDER]);
  pairs.push([Constants.mobile, user.MOBILE]);
  pairs.push([Constants.location, user.LOCATION]);
  pairs.push([Constants.maritalStatus, user.MARITAL_STATUS]);
  pairs.push([Constants.numOfChildren, user.NUM_OF_CHILDREN]);
  pairs.push([Constants.address, user.ADDRESS]);
  pairs.push([Constants.loggedIn, Constants.LOGGED_IN]);
  pairs.push([
    Constants.isAdmin,
    user.ISADMIN === undefined ? "0" : user.ISADMIN + "",
  ]);
  await multiSaveToAS(pairs);
};

export const resetUserInfo = async () => {
  const pairs = [];
  pairs.push([Constants.email, ""]);
  pairs.push([Constants.username, ""]);
  pairs.push([Constants.password, ""]);
  pairs.push([Constants.firstName, ""]);
  pairs.push([Constants.lastName, ""]);
  pairs.push([Constants.birthdate, ""]);
  pairs.push([Constants.gender, ""]);
  pairs.push([Constants.mobile, ""]);
  pairs.push([Constants.location, ""]);
  pairs.push([Constants.maritalStatus, ""]);
  pairs.push([Constants.numOfChildren, ""]);
  pairs.push([Constants.address, ""]);
  pairs.push([Constants.loggedIn, Constants.LOGGED_OUT]);
  await multiSaveToAS(pairs);
};

export const getUserObject = SharedUtils.getUserObject;
const searchIcon = require("../assets/icons/search.png");
const renderMapViewAddressSelection = (self) => (
  <Modal
    ref={(el) => (self.mapViewModal = el)}
    position={"top"}
    animationDuration={250}
    style={[Styles.modal, { marginTop: 100 }]}
    entry="top"
    swipeToClose={false}
    backButtonClose
    onOpened={() => {
      self.props.updateState({ showMap: true });
    }}
    onClosed={() =>
      self.props.updateState({
        showMap: false,
        cachedMapKey: self.props.cachedMapKey + 1,
      })
    }
  >
    <View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginVertical: 20,
        }}
      >
        <TextInput
          style={[
            Styles.orderNote,
            {
              flex: 1,
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize,
            },
          ]}
          placeholder={STRINGS.address}
          value={self.props.address}
          underlineColorAndroid="transparent"
          onChangeText={(text) => self.props.updateState({ address: text })}
          onBlur={() => {
            self.applyLocationFromAddress(self.props.address);
          }}
          selectTextOnFocus
        />
        <TouchableOpacity
          style={{
            width: 36,
            height: 36,
            alignItems: "center",
            justifyContent: "center",
            // backgroundColor: Color.BLUE[500],
            borderRadius: 2,
            marginLeft: -30,
          }}
          onPress={() => {
            Keyboard.dismiss();
            self.applyLocationFromAddress(self.props.address);
          }}
        >
          {/* <Ionicons name="md-search" size={24} color="white" /> */}
          <Image
            style={{
              width: 18,
              height: 18,
              marginTop: 3,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
            }}
            source={searchIcon}
          />
        </TouchableOpacity>
      </View>
      {self.props.showMap && (
        <View
          style={{
            height: 300,
            width: '99%',
            flexDirection: "row",
            alignSelf: "center",
          }}
        >
          <MapView
            ref={(el) => (self.mapView = el)}
            initialRegion={{
              latitude: self.props.userLocation.latitude,
              longitude: self.props.userLocation.longitude,
              latitudeDelta: 0.00595,
              longitudeDelta: 0.007,
            }}
            minZoomLevel={14}
            googleMapsApiKey={"AIzaSyAsZsz6Yh4G_88061k71jnfLOMgTxw5YUM"}
            provider="google"
            // onRegionChange={region => self.onRegionChange(region)}
            onRegionChangeComplete={(region) =>
              self.onRegionChange(region, true)
            }
          >
            <Marker
              key="address-marker"
              coordinate={{
                latitude: self.props.userLocation.latitude,
                longitude: self.props.userLocation.longitude,
              }}
              title=""
              description=""
            />
          </MapView>
        </View>
      )}
      {/* <TouchableOpacity
        style={{ alignSelf: "flex-end", margin: 10 }}
        onPress={self.getUserLocation}
      >
        <Image
          style={{
            width: 25,
            height: 25,
            marginTop: 3,
            padding: 1,
            resizeMode: "contain",
            tintColor: "#6b3529",
          }}
          source={locationIcon}
        />
      </TouchableOpacity> */}
    </View>
    <View
      style={{
        alignSelf: "flex-end",
        flexDirection: "row",
        marginTop: 5,
        marginEnd: 10
      }}
    >
      {/* <Button
        title={STRINGS.navigate_to_location}
        onPress={() => navigate(self)}
      />
      <View style={{ marginHorizontal: 2 }}></View> */}
      <Button title={STRINGS.done} onPress={() => self.mapViewModal.close()} />
    </View>
  </Modal>
);

export const navigate = (self) => {
  const location = `${self.props.userLocation.latitude},${self.props.userLocation.longitude}`;
  let f = Platform.select({
    ios: () => {
      Linking.openURL(`http://maps.google.com/maps?daddr=${location}`);
    },
    android: () => {
      console.log("ANDROID");
      Linking.openURL(`http://maps.google.com/maps?daddr=${location}`).catch(
        (err) => console.error("An error occurred", err)
      );
    },
  });
  f();
};

export const checkUserToken = async () => {
  const token = await getFromAS(Constants.TOKEN);
  if (token == null || token == undefined || token == "") {
    return false;
  }
  const resp = await ServerOperations.checkToken();
  return resp.VALID;
};

export const renderPaymentModal = (self) => (
  <Modal
    ref={(el) => (self.webViewModal = el)}
    style={[Styles.fullModal, { marginBottom: 0 }]}
    position={"center"}
    animationDuration={250}
    entry="top"
    swipeToClose={false}
    backButtonClose
    onOpened={() => { }}
    onClosed={() => { }}
  >
    <WebView
      ref={(ref) => {
        self.myWebView = ref;
      }}
      originWhitelist={["*"]}
      scalesPageToFit={false}
      onMessage={(event) => {
        try {
          const resp = JSON.parse(event.nativeEvent.data);
          console.log(resp);
          if (resp.RESULT === "OK") {
            okMsgAlert(STRINGS.paid_successfully);
            // self.orderModal.close();
            // self.props.loadMyOrders(self);
            self.props.updateState({ payment_reqid: resp.REF });
            setTimeout(() => {
              // self.props.confirmOrder(self);
              okMsgAlert(STRINGS.order_sent_successfully);
              // self.props.navigation.push('myorders', {});
              // self.props.route.params.restart()
              // self.props.navigation.push('offers', {})
            }, 1000);
          } else {
            okMsgAlert(STRINGS.payment_error);
          }
          console.log(resp);
          self.webViewModal.close();
        } catch (err) { }
      }}
      source={{ uri: self.props.paymentURI }}
      style={{ marginTop: -20 }}
      sharedCookiesEnabled={true}
      thirdPartyCookiesEnabled={true}
    />
  </Modal>
);
const checkboxIcon = require("../assets/md-checkbox-outline.png");
const squareIcon = require("../assets/md-square-outline.png");

const renderMapComponent = (self, items, rightFN, fromMyOrders = false) => {
  return (<TouchableOpacity style={{ height: 250, width: width / 2, minWidth: 640, flexDirection: "row" }}>
    <MapView
      onPress={() => {
        if (!fromMyOrders) {
          self.mapViewModal.open();
        }
      }}
      key={`${self.props.cachedMapKey}`}
      googleMapsApiKey={"AIzaSyAsZsz6Yh4G_88061k71jnfLOMgTxw5YUM"}
      region={{
        latitude: self.props.userLocation.latitude,
        longitude: self.props.userLocation.longitude,
        latitudeDelta: 0.00595,
        longitudeDelta: 0.007,
      }}
      initialRegion={{
        latitude: self.props.userLocation.latitude,
        longitude: self.props.userLocation.longitude,
        latitudeDelta: 0.00595,
        longitudeDelta: 0.007,
      }}
      minZoomLevel={14}
      provider="google"
      zoomControlEnabled={false}
      toolbarEnabled={false}
      scrollEnabled={false}
      pitchEnabled={false}
    >
      <Marker
        key="address-marker-cached"
        coordinate={{
          latitude: self.props.userLocation.latitude,
          longitude: self.props.userLocation.longitude,
        }}
      />
    </MapView>
    {!fromMyOrders &&
      <TouchableOpacity
        onPress={() => {
          self.mapViewModal.open();
        }}
        style={{
          flexDirection: "row",
          position: "absolute",
          bottom: 30,
          width: width / 2 - 100,
          minWidth: 550,
          backgroundColor: "white",
          padding: 10,
          marginLeft: 20,
          alignItems: "flex-start",
          justifyContent: "space-between"
        }}
      >
        <Text
          style={{
            fontFamily: self.props.fontFamily,
            fontSize: self.props.fontSize - 2,
            color: "#6b3529",
          }}
        >
          {STRINGS.click_the_map_to_add_your_address}
        </Text>
        <Image
          style={{
            width: 15,
            height: 15,
            resizeMode: "contain",
            tintColor: "#6b3529",
            alignSelf: "flex-end"
          }}
          source={searchIcon}
        />
      </TouchableOpacity>
    }
  </TouchableOpacity>);
}

export const renderDeliveryDateSelect = (self, fromMyOrders = false) => {
  return (<View
    style={{
      alignSelf: "flex-start",
      width: width / 5,
      minWidth: 320,
      marginLeft: 50,
      marginTop: 20,
    }}
  >
    <Text
      style={{
        fontFamily: self.props.fontFamily,
        fontSize: self.props.fontSize - 1,
        color: "#6b3529",
        fontWeight: "bold",
      }}
    >
      {" "}
      {STRINGS.select_delivery_date}{" "}
    </Text>
    <View style={{ flexDirection: "row", marginTop: 10 }}>
      <Picker
        style={Styles.dateTextInput}
        selectedValue={self.props.day}
        onValueChange={(day) =>
          self.props.updateState({ day })
        }>
        {getDays(self.props.month, self.props.year, self)}
      </Picker>
      <Picker
        style={Styles.dateTextInput}
        selectedValue={self.props.month}
        onValueChange={(month) =>
          self.props.updateState({ month })
        }>
        {getMonths(self.props.year)}
      </Picker>

      <Picker
        style={[Styles.dateTextInput, { width: 75 }]}
        selectedValue={self.props.year}
        onValueChange={(year) =>
          self.props.updateState({ year })
        }>
        {getYears()}
      </Picker>
    </View>
    <Text style={{
      marginTop: 10,
      alignSelf: "flex-start",
      fontFamily: "zarid",
      textAlign: "left",
      fontSize: self.props.fontSize - 1,
      color: "#6b3529",
    }}>
      {STRINGS.dlv_time_note}{" "}
    </Text>
    <View style={{}}>
      <Text
        style={{
          fontFamily: self.props.fontFamily,
          fontSize: self.props.fontSize,
          color: "#6b3529",
          marginTop: 20,
        }}
      >
        {" "}
        {STRINGS.select_delivery_time}{" "}
      </Text>
      <View>
        {renderDeliveryTimes(self)}
      </View>
    </View>
  </View>)
}

export const renderPaymentMethod = (self, fromMyOrders = false) => {
  return (
    <View>
      <View style={{ flexDirection: "row" }}>
        <Text
          style={{
            fontFamily: self.props.fontFamily,
            fontSize: self.props.fontSize,
            color: "#6b3529",
            fontWeight: "bold",
          }}
        >
          {" "}
          {STRINGS.pay_method}{" "}
        </Text>
      </View>
      <View
        style={{
          flexDirection: "column",
          width: width / 5,
          marginLeft: 10,
        }}
      >
        <TouchableOpacity
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
          }}
          onPress={() => {
            self.props.updateState({ payment_method: "CASH" });
          }}
        >
          <Image
            style={{
              width: 18,
              height: 18,
              marginTop: 3,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
            }}
            source={self.props.payment_method === "CASH" ? checkboxIcon : squareIcon}
          />
          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize - 3,
              color: "#6b3529",
              marginVertical: 5,
            }}
          >
            {" "}
            {STRINGS.cash_on_delivery}{" "}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 6,
          }}
          onPress={() => {
            self.props.updateState({ payment_method: "Visa" });
          }}
        >
          <Image
            style={{
              width: 18,
              height: 18,
              marginTop: 3,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
            }}
            source={self.props.payment_method === "Visa" ? checkboxIcon : squareIcon}
          />
          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize - 3,
              color: "#6b3529",
              marginVertical: 5,
            }}
          >
            {" "}
            {STRINGS.visa_on_delivery}{" "}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 6,
          }}
          onPress={() => {
            self.props.updateState({ payment_method: "ONLINE" });
          }}
        >
          <Image
            style={{
              width: 18,
              height: 18,
              marginTop: 3,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
            }}
            source={self.props.payment_method === "ONLINE" ? checkboxIcon : squareIcon}
          />
          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize - 3,
              color: "#6b3529",
            }}
          >
            {" "}
            {STRINGS.pay_now}{" "}
          </Text>
        </TouchableOpacity>
        {Styles.renderVSeparator(24)}
      </View>
    </View>
  )
}

export const renderDeliveryMethod = (self, items, rightFN, fromMyOrders = false) => {
  if (!self.props.showCachedMap) return;
  return (
    <View
      style={{
        width: 250,
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          fontFamily: self.props.fontFamily,
          fontSize: self.props.fontSize - 1,
          color: "#6b3529",
          marginBottom: 20,
          marginTop: 10,
        }}
      >
        {" "}
        {STRINGS.delivery_method}{" "}
      </Text>
      {fromMyOrders && (
        <TouchableOpacity
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginLeft: 10,
            marginBottom: 5,
          }}
          onPress={() => {
            const userLocation = {
              latitude: parseFloat(
                self.props.locations[0].LOCATION.split(",")[0]
              ),
              longitude: parseFloat(
                self.props.locations[0].LOCATION.split(",")[1]
              ),
            };
            self.props.updateState({
              address: self.props.locations[0].ADDRESS,
              userLocation,
            });
            self.props.calcOrderPrice(self);
          }}
        >
          <Image
            style={{
              width: 18,
              height: 18,
              marginTop: 3,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
            }}
            source={checkboxIcon}
          />

          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize,
              color: "#6b3529",
            }}
          >
            {" "}
            {self.props.address.toUpperCase()}{" "}
          </Text>
        </TouchableOpacity>
      )}
      {self.props.locations !== undefined &&
        self.props.locations !== null &&
        self.props.locations.length > 0 && (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10,
              marginBottom: 5,
            }}
            onPress={() => {
              const userLocation = {
                latitude: parseFloat(
                  self.props.locations[0].LOCATION.split(",")[0]
                ),
                longitude: parseFloat(
                  self.props.locations[0].LOCATION.split(",")[1]
                ),
              };
              self.props.updateState({
                address: self.props.locations[0].ADDRESS,
                userLocation,
                cachedMapKey: self.props.cachedMapKey + 1,
              });
              self.props.calcOrderPrice(self);
            }}
          >
            {self.props.address.toUpperCase() ===
              self.props.locations[0].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={checkboxIcon}
                />
              )}
            {self.props.address.toUpperCase() !==
              self.props.locations[0].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={squareIcon}
                />
              )}
            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 3,
                color: "#6b3529",
              }}
            >
              {" "}
              {self.props.locations[0].ADDRESS.toUpperCase()}{" "}
            </Text>
          </TouchableOpacity>
        )}
      {self.props.locations !== undefined &&
        self.props.locations !== null &&
        self.props.locations.length > 1 && (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10,
              marginBottom: 5,
            }}
            onPress={() => {
              const userLocation = {
                latitude: parseFloat(
                  self.props.locations[1].LOCATION.split(",")[0]
                ),
                longitude: parseFloat(
                  self.props.locations[1].LOCATION.split(",")[1]
                ),
              };
              self.props.updateState({
                address: self.props.locations[1].ADDRESS,
                userLocation,
                cachedMapKey: self.props.cachedMapKey + 1,
              });
              self.props.calcOrderPrice(self);
            }}
          >
            {self.props.address.toUpperCase() ===
              self.props.locations[1].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={checkboxIcon}
                />
              )}
            {self.props.address.toUpperCase() !==
              self.props.locations[1].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={squareIcon}
                />
              )}
            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 3,
                color: "#6b3529",
              }}
            >
              {" "}
              {self.props.locations[1].ADDRESS.toUpperCase()}{" "}
            </Text>
          </TouchableOpacity>
        )}

      {self.props.locations !== undefined &&
        self.props.locations !== null &&
        self.props.locations.length > 2 &&
        self.props.pickupAddress ==
        self.props.locations[2].ADDRESS && (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10,
            }}
            onPress={() => {
              const userLocation = {
                latitude: parseFloat(
                  self.props.locations[2].LOCATION.split(",")[0]
                ),
                longitude: parseFloat(
                  self.props.locations[2].LOCATION.split(",")[1]
                ),
              };
              self.props.updateState({
                address: self.props.locations[2].ADDRESS,
                userLocation,
                cachedMapKey: self.props.cachedMapKey + 1,
              });
              self.props.calcOrderPrice(self);
            }}
          >
            {self.props.address.toUpperCase() ===
              self.props.locations[2].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={checkboxIcon}
                />
              )}
            {self.props.address.toUpperCase() !==
              self.props.locations[2].ADDRESS.toUpperCase() && (
                <Image
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    padding: 1,
                    resizeMode: "contain",
                    tintColor: "#6b3529",
                  }}
                  source={squareIcon}
                />
              )}
            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 3,
                color: "#6b3529",
              }}
            >
              {" "}
              {self.props.locations[2].ADDRESS.toUpperCase()}{" "}
            </Text>
          </TouchableOpacity>
        )}
      {((self.props.locations !== undefined &&
        self.props.locations !== null &&
        self.props.locations.length == 2 &&
        self.props.address.toUpperCase() !==
        self.props.locations[0].ADDRESS.toUpperCase() &&
        self.props.address.toUpperCase() !==
        self.props.locations[1].ADDRESS.toUpperCase()) ||
        (self.props.locations !== undefined &&
          self.props.locations !== null &&
          self.props.locations.length == 3 &&
          self.props.address.toUpperCase() !==
          self.props.locations[0].ADDRESS.toUpperCase() &&
          self.props.address.toUpperCase() !==
          self.props.locations[1].ADDRESS.toUpperCase() &&
          self.props.address.toUpperCase() !==
          self.props.locations[2].ADDRESS.toUpperCase()) ||
        (self.props.locations !== undefined &&
          self.props.locations !== null &&
          self.props.locations.length == 1 &&
          self.props.address.toUpperCase() !==
          self.props.locations[0].ADDRESS.toUpperCase())) && (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10,
            }}
          >
            <Image
              style={{
                width: 18,
                height: 18,
                marginTop: 3,
                padding: 1,
                resizeMode: "contain",
                tintColor: "#6b3529",
              }}
              source={checkboxIcon}
            />

            <Text
              style={{
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize,
                color: "#6b3529",
              }}
            >
              {" "}
              {self.props.address.toUpperCase()}{" "}
            </Text>
          </TouchableOpacity>
        )}
      <TextInput
        style={{
          fontFamily: self.props.fontFamily,
          fontSize: self.props.fontSize - 2,
          padding: 12,
          color: "gray",
          marginBottom: 10,
        }}
        selectTextOnFocus
        placeholder={STRINGS.add_address_note}
        placeholderTextColor="gray"
        value={self.props.addressNote}
        underlineColorAndroid="transparent"
        onChangeText={(text) =>
          self.props.updateState({ addressNote: text })
        }
        editable={!fromMyOrders}
      />
    </View>
  )
}

export const renderOrderSummary = (self, items, rightFN, fromMyOrders) => {
  return (
    <View
      style={{
        marginRight: (width / 2 - 150) < 400 ? 20 : 75,
        width: width / 2 - 150,
        minWidth: 400
      }}
    >
      <View style={{ backgroundColor: "#f2f2f2", }}>
        <Text
          style={{
            fontFamily: self.props.fontFamily,
            fontSize: self.props.fontSize,
            color: "#6b3529",
            alignSelf: "flex-start",
            marginLeft: 20,
            marginTop: 10,
          }}
        >
          {STRINGS.order_summary}
        </Text>
        {Styles.renderVSeparator(6)}
        <FlatList
          key={Math.random()}
          data={items}
          renderItem={({ item }) =>
            renderOrderItemRow(self, item, fromMyOrders)
          }
          keyExtractor={(item) => item.ID}
          showsVerticalScrollIndicator
          scrollEnabled={true}
          style={{
            alignSelf: "flex-start",
            maxHeight: 350
          }}
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 4,
          backgroundColor: "#ececec",
          paddingVertical: 10
        }}
      >
        <View style={{ flex: 1 }}>
          {
            self.props.credit != 0 && [
              <Text
                style={[
                  Styles.subItemText,
                  {
                    fontFamily: self.props.fontFamily,
                    fontSize: self.props.fontSize,
                    marginLeft: 15,
                    marginVertical: 5,
                  },
                ]}
              >
                {STRINGS.credit}
              </Text>,
              Styles.renderVSeparator(4)
            ]
          }
          <Text
            style={[
              Styles.subItemText,
              {
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize,
                marginLeft: 15,
              },
            ]}
          >
            {STRINGS.tax}
          </Text>
          {Styles.renderVSeparator(4)}
          <Text
            style={[
              Styles.subItemText,
              {
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize,
                marginLeft: 15,
                marginVertical: 5,
              },
            ]}
          >
            {STRINGS.delivery}
          </Text>
          {Styles.renderVSeparator(4)}
          <Text
            style={[
              Styles.subItemText,
              {
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize,
                marginLeft: 15,
              },
            ]}
          >
            {STRINGS.subtotal}
          </Text>
        </View>
        <View style={{ justifyContent: "flex-end", flex: 0.75, marginRight: 15 }}>
          {
            self.props.credit != 0 && [
              <Text
                style={[
                  Styles.subItemText,
                  {
                    textAlign: "right",
                    flex: 1,
                    fontSize: self.props.fontSize,
                    marginRight: 5,
                    marginVertical: 5,
                  },
                ]}
              >
                {self.props.credit.toFixed(3)} {STRINGS.jd}
              </Text>,
              Styles.renderVSeparator(4)
            ]
          }
          <Text
            style={[
              Styles.subItemText,
              {
                textAlign: "right",
                flex: 1,
                fontSize: self.props.fontSize,
                marginRight: 5,
              },
            ]}
          >
            {self.props.Tax.toFixed(3)} {STRINGS.jd}
          </Text>
          {Styles.renderVSeparator(4)}
          <Text
            style={[
              Styles.subItemText,
              {
                textAlign: "right",
                flex: 1,
                fontSize: self.props.fontSize,
                marginRight: 5,
                marginVertical: 5,
              },
            ]}
          >
            {self.props.deliveryCharge.toFixed(3)} {STRINGS.jd}
          </Text>
          {Styles.renderVSeparator(4)}
          <Text
            style={[
              Styles.subItemText,
              {
                textAlign: "right",
                flex: 1,
                fontSize: self.props.fontSize,
                marginRight: 5,
              },
            ]}
          >
            {self.props.Net.toFixed(3)} {STRINGS.jd}
          </Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          marginTop: 10,
          alignSelf: "flex-end",
          width: "100%",
        }}
      >
        <TouchableOpacity
          style={{ backgroundColor: "#6b3529", flex: 0.5 }}
          onPress={rightFN}
        >
          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize + 3,
              color: "white",
              textAlign: "center",
              padding: 10
            }}
          >
            {STRINGS.checkout}
          </Text>
        </TouchableOpacity>
        <View style={{ backgroundColor: "#ececec", flex: 0.5 }}>
          <Text
            style={{
              fontFamily: self.props.fontFamily,
              fontSize: self.props.fontSize + 3,
              color: "#6b3529",
              textAlign: "center",
              padding: 10
            }}
          >
            {STRINGS.total}
            {":  "}
            {(
              self.props.Net +
              self.props.deliveryCharge -
              self.props.credit
            ).toFixed(3)}
            {" JD"}
          </Text>
        </View>
      </View>
    </View>
  )
}

export const renderOrderModal = (
  self,
  items,
  rightFN,
  fromMyOrders = false,
  leftFN
) => {
  width = getWidth();
  return [
    <Modal
      ref={(el) => (self.orderModal = el)}
      style={{ width: "100%", height: "100%" }}
      position={"center"}
      animationDuration={250}
      entry="top"
      swipeToClose={false}
      backButtonClose
      onOpened={() => self.props.updateState({ showCachedMap: true })}
      onClosed={() => self.props.updateState({ showCachedMap: false })}
    >
      {
        <Header
          title={STRINGS.company_name}
          leftView={Styles.backButton(self.orderModal)}
          navigation={self.props.navigation}
          light
          showBasketView={() => {
            self.orderModal.close();
          }}
          toggleSearchBar={() => self.toggleSearchBar()}
          badgeText={self.props.badgeText}
          isSearchBarVisible={self.state.showSearchBar}
          search={(text) => { self.setState({ searchText: text }) }}
          searchText={self.state.searchText}
        />
      }
      {renderMapViewAddressSelection(self)}
      <ScrollView
        ref={(ref) => {
          self.scrollRef = ref;
        }}
        keyboardShouldPersistTaps={"always"}
        contentContainerStyle={[
          Styles.fullModalView,
          { marginTop: 100, width: width },
        ]}
      >
        <Text
          style={{
            fontFamily: self.props.fontFamily,
            fontSize: self.props.fontSize + 3,
            color: "#6b3529",
            alignSelf: "flex-start",
            marginLeft: 20,
            marginTop: 10,
          }}
        >
          {STRINGS.checkout}
        </Text>
        <View
          style={{
            fontWeight: "bold",
            borderBottomColor: "#6b3529",
            borderBottomWidth: 3,
            alignSelf: "flex-start",
            marginLeft: 20,
            width: 25,
            marginTop: 5,
            marginBottom: 10
          }}
        >
        </View>
        <View style={{ flexDirection: "row", width: width, justifyContent: "space-between" }}>
          <View>
            {renderMapComponent(self, items, rightFN, fromMyOrders, leftFN)}
            <View
              style={{
                flexDirection: "row-reverse",
                alignSelf: "flex-start",
              }}
            >
              {renderDeliveryDateSelect(self, items, rightFN, fromMyOrders, leftFN)}
              <View
                style={{
                  alignSelf: "flex-start",
                  width: 240,
                  marginLeft: 40,
                  marginTop: 10,
                }}
              >
                {renderDeliveryMethod(self, items, rightFN, fromMyOrders, leftFN)}
                {renderPaymentMethod(self, items, rightFN, fromMyOrders, leftFN)}
              </View>
            </View>
          </View>
          {renderOrderSummary(self, items, rightFN, fromMyOrders, leftFN)}
        </View>
        <TouchableOpacity style={{
          alignSelf: "flex-start",
          color: "#6b3529",
          flexDirection: "row",
          marginLeft: 20,
        }}
          onPress={() => { self.orderModal.close() }}>
          <Image
            style={{
              width: 12,
              height: 12,
              padding: 1,
              resizeMode: "contain",
              tintColor: "#6b3529",
              marginTop: 2
            }}
            source={arrowLeftIcon}
          />
          <Text style={{
            fontFamily: self.props.fontFamily,
            fontSize: self.props.fontSize - 3,
            marginLeft: 10,
            color: "#6b3529"
          }}>
            {STRINGS.back_to_shop_page}
          </Text>
        </TouchableOpacity>
        {Styles.renderVSeparator(50)}
      </ScrollView>

    </Modal>,
    renderPaymentModal(self)
  ]
};

export const renderOrderItemRow = (self, item, fromMyOrders = false) => {
  return [
    getMainItem(self, item, fromMyOrders, false),
    getMainItem(self, item, fromMyOrders, true),
    // getSubItems(self, item),
  ];
};

const getMainItem = (self, item, fromMyOrders, isBon) => {
  if (isBon && item.Bonus <= 0) {
    return undefined;
  }
  if (!isBon && item.Qty <= 0) {
    return undefined;
  }

  return [
    <View
      style={[
        Styles.itemRowView,
        {
          justifyContent: "space-between",
          borderBottomWidth: 0,
          marginLeft: 15,
          minWidth: 360,
          width: width / 2 - 150,
          paddingRight: 25
        },
      ]}
    >
      <View style={[Styles.subItemRowView]}>
        <Image
          style={(Styles.orderAvatar, { width: 60, height: 60 })}
          resizeMode="stretch"
          source={{ uri: item.ImageURL }}
        />
        {Styles.renderSeparator(6)}
        <View style={{ marginLeft: 10 }}>
          <Text
            style={[
              Styles.subItemText,
              {
                fontFamily: 'zarid',
                fontSize: self.props.fontSize,
                width: 130
              },
              item.OrgQty !== undefined && item.OrgQty - item.Qty != 0 && !isBon
                ? { color: Red }
                : {},
            ]}
          >
            {getItemName(item).toUpperCase()}
          </Text>
          {Styles.renderVSeparator(6)}
          <Text
            style={[
              {
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 4,
                color: "#6b3529",
              },
            ]}
          >
            {getItemUnit(item)}
          </Text>
          <Text
            style={[
              {
                fontFamily: self.props.fontFamily,
                fontSize: self.props.fontSize - 4,
                color: "#6b3529",
              },
            ]}
          >
            {`${parseFloat(item.Price).toFixed(2)} ${STRINGS.jd}`}
          </Text>
        </View>
      </View>
      <View
        style={[
          Styles.subItemRowView,
          {
            justifyContent: "center",
          },
        ]}
      >
        {!fromMyOrders && (
          <TouchableOpacity
            style={{ padding: 2 }}
            onPress={() => self.changeQty(item, Constants.INCREASE)}
          >
            <Text style={{
              fontSize: 22,
              fontFamily: "zarid",
              color: "#6b3529",
            }}>{"+"}</Text>
          </TouchableOpacity>
        )}
        {(item.SubItems == undefined ||
          item.SubItems.length <= 0 ||
          item.HideSubItems) && (
            <Text
              style={[
                Styles.subItemText,
                {
                  paddingHorizontal: 5,
                },
              ]}
            >
              {isBon
                ? item.Bonus
                : item.OrgQty !== undefined && item.OrgQty - item.Qty != 0
                  ? item.OrgQty + " > " + item.Qty
                  : item.Qty}
            </Text>
          )}
        {!fromMyOrders && (
          <TouchableOpacity
            style={{ padding: 2 }}
            onPress={() => self.changeQty(item, Constants.DECREASE)}
          >
            <Text style={{
              fontSize: 22,
              fontFamily: "zarid",
              color: "#6b3529",
            }}>{"-"}</Text>
          </TouchableOpacity>
        )}
      </View>
      <View style={[Styles.subItemRowView]}>
        {(item.SubItems == undefined ||
          item.SubItems.length <= 0 ||
          item.HideSubItems) && (
            <Text
              style={[
                Styles.subItemText,
                {
                  paddingHorizontal: 5,
                },
              ]}
            >
              {parseFloat(isBon ? 0 : item.Price * item.Qty).toFixed(2)}{" "}
              {STRINGS.jd}
            </Text>
          )}
      </View>
    </View>,
  ];
};






export const loadMenuItems = async (dispatch, self) => {
  setTimeout(() => {
    console.log(self);
    loaderHandler.showLoader(STRINGS.loading, self);
  }, 25);
  const items = await ServerOperations.loadMenuItems();
  items.sort((a, b) => {
    if (a.CIndex === "-1") {
      a.CIndex = "";
    }
    if (b.CIndex === "-1") {
      b.CIndex = "";
    }
    if (parseFloat(b.AVLQTY) < 1) {
      b.CIndex = "z";
    }
    if (parseFloat(a.AVLQTY) < 1) {
      a.CIndex = "z";
    }
    const nameA = STRINGS.curLanguage.startsWith("ar")
      ? a.CIndex + a.ArName.toUpperCase()
      : a.CIndex + a.EnName.toUpperCase();
    const nameB = STRINGS.curLanguage.startsWith("ar")
      ? b.CIndex + b.ArName.toUpperCase()
      : b.CIndex + b.EnName.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });
  // saveFile(JSON.stringify(items));
  dispatch({ type: types.DELIVERY_LOAD_ITEMS, payload: items });
  setTimeout(() => {
    loaderHandler.hideLoader();
  }, 500);
};

// const saveFile = async (txt) => {
//   const { status } = await Permissions.askAsync(Permissions.CAMERA_ROLL);
//   if (status === "granted") {
//     let fileUri = FileSystem.documentDirectory + "text.json";
//     await FileSystem.writeAsStringAsync(fileUri, txt, { encoding: FileSystem.EncodingType.UTF8 });
//     const asset = await MediaLibrary.createAssetAsync(fileUri)
//     await MediaLibrary.createAlbumAsync("Download", asset, false)
//   }
// }

export const setUserLocation = async () => {
  const { USERNAME } = await getUserObject();
  let resp = await ServerOperations.getUserLocation(USERNAME);
  if (resp.LOCATION !== undefined && resp.LOCATION !== "") {
    const location = resp.LOCATION;
    const address = resp.ADDRESS;
    const addressNote = resp.ADDRESS_NOTE;
    const mobile = resp.MOBILE;
    if (location.length > 5) {
      saveToAS(Constants.location, location);
      saveToAS(Constants.address, address);
      saveToAS(Constants.addressNote, addressNote);
      saveToAS(Constants.mobile, mobile);
    }
  }
  // resp = await ServerOperations.getUserLocations(USERNAME);
  // if (resp !== undefined && resp !== '') {
  //   saveToAS(Constants.locations, resp);
  //   console.log(resp);
  // }
};

export const switchLanguage = async () => {
  if (STRINGS.curLanguage.startsWith("ar")) {
    await saveToAS(Constants.language, "en");
  } else {
    await saveToAS(Constants.language, "ar");
  }
  // Updates.reload();
};

export const renderAppBackground = (img) => {
  if (img === undefined) img = null;
  return (
    <View style={Styles.fillAbsolute}>
      <Image style={Styles.appBackground} resizeMode="stretch" source={img} />
      <View
        style={[Styles.fillAbsolute, { backgroundColor: "rgba(0,0,0,0.5)" }]}
      />
    </View>
  );
};

export const addNotification = async (notification) => {
  const notifications = await getNotifcations();
  notifications.data.unshift(notification);
  const data = JSON.stringify(notifications);
  await saveToAS(Constants.NOTIFICATIONS, data);
};

export const getNotifcations = async () => {
  let notifications = await getFromAS(Constants.NOTIFICATIONS);
  if (notifications == null) notifications = { data: [] };
  try {
    notifications = JSON.parse(notifications);
  } catch (err) {
    notifications = { data: [] };
  }
  return notifications;
};

export const clearNotifications = async () => {
  const notifications = await getNotifcations();
  notifications.data.map((l) => {
    l.READ = 1;
  });
  const data = JSON.stringify(notifications);
  await saveToAS(Constants.NOTIFICATIONS, data);
};

export const schedualReminders = async () => {
  await cancelAllNotifications();
  if (true) {
    return;
  }
};


export const schedualNotifications = (DAYS = null) => {
  if (true) return;
};

export const cancelAllNotifications = async () => { };

export const getPushNotificationsToken = async () => { };

export const addressExists = (user) =>
  user !== "" && user.ADDRESS !== null && user.ADDRESS.trim() !== "";
export const mobileExists = (user) =>
  user !== "" && user.MOBILE !== null && user.MOBILE.trim() !== "";

export const getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
}

export const getDays = (selectedMonth, selectedYear, self) => {
  const date = new Date();

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const startDay = selectedYear == year && selectedMonth == month ? day : 1;
  const endDay = getDaysInMonth(selectedMonth, selectedYear);
  const days = [];
  const { deliveryDays, deliveryIncDays, deliveryExcDays } = self.props;
  if (deliveryDays == undefined) return;
  for (let i = startDay; i <= endDay; i++) {
    const dt = new Date(new Date(selectedYear, selectedMonth - 1, i));
    const day = dayNamesEN[dt.getDay()];
    const dtStr = moment(dt).format("YYYY-MM-DD");
    if (!deliveryDays.includes(day) && !deliveryIncDays.includes(dtStr)) {
      continue;
    }
    if (deliveryExcDays.includes(dtStr)) {
      continue;
    }
    if (moment(dt).isAfter(moment(self._minimumDate))) {
      days.push(
        <Picker.Item label={i} value={i} />
      );
    }
  }
  console.log(self.props.deliveryDays);
  console.log(self.props.deliveryIncDays);
  console.log(self.props.deliveryExcDays);
  return days;
}

export const getMonths = (selectedYear) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const startMonth = selectedYear == year ? month : 1;
  const months = [];
  for (let i = startMonth; i <= 12; i++) {
    months.push(
      <Picker.Item label={i} value={i} />
    );
  }
  return months;
}

export const getYears = () => {
  const date = new Date();
  const year = date.getFullYear();
  return [
    <Picker.Item label={`${year}`} value={`${year}`} />,
    <Picker.Item label={`${year + 1}`} value={`${year + 1}`} />
  ]
}
export const dayNamesEN = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];


export const footerFooterMobile = (style, self) => {
  return (
    <View
      style={[{
        width: self.props.width,
        paddingVertical: 32,
        paddingHorizontal: 20
      }, style]}>

      <TouchableOpacity style={{ gap: 31 }} onPress={() => {
        window.location = './home';
      }}>
        <Image
          style={{
            width: 142,
            height: 44,
            padding: 1,
            resizeMode: "contain",
          }}
          source={drawerIconImgLight}
        />
        <View>
          {renderFooterItemMobile(self, 'Privacy')}
          {renderFooterItemMobile(self, 'Terms and conditions')}
          {renderFooterItemMobile(self, 'Contact Us', () => window.location = './contactus')}
          {renderFooterItemMobile(self, 'Careers', () => window.location = './careers')}
        </View>
        <View>
          {renderFooterItemMobile(self, 'Follow @jordandrugstoreco', () => Linking.openURL("https://www.instagram.com/jordandrugstoreco/?hl=en"))}
          {Styles.renderVSeparator(20)}
          <View style={{ gap: 11.23, flexDirection: "row" }}>
            {renderFooterImageMobile(self, 'facebook', faceBookIcon, faceBookHoveredIcon, () => Linking.openURL("https://www.facebook.com/jordandrugstoreco/?_rdr"))}
            {renderFooterImageMobile(self, 'linkedin', linkedinIcon, linkedinHoveredIcon, () => Linking.openURL("https://www.linkedin.com/company/jordan-drugstore-co/?viewAsMember=true"))}
            {renderFooterImageMobile(self, 'instagram', instagramIcon, instagramHoveredIcon, () => Linking.openURL("https://www.instagram.com/jordandrugstoreco/?hl=en"))}
          </View>
        </View>
        {renderFooterItemMobile(self, 'Copyright ©2023 Jordan Drugstore Co. All Rights Reserved.', undefined, { fontSize: 12 })}
      </TouchableOpacity>

    </View >
  );
}

export const addToCartButton = (self, item, itemID) => {
  let qty = self.state[`itemQty${item.ID}`] && self.state[`itemQty${item.ID}`] ? self.state[`itemQty${item.ID}`] : 1;
  if (self.state[`cartPressed_${item.ID}`] === undefined) {
    self.state[`cartPressed_${item.ID}`] = checkItemIsInBasket(self, item.ID).inBasket;
  }
  if (!self[`qtyAnimRef_${itemID}`]) self[`qtyAnimRef_${itemID}`] = React.createRef();

  return (
    <View style={{ justifyContent: 'center', alignItems: 'center' }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: 4, }}>
        <Image source={giftIcon} style={{ width: 12.016, height: 12.084, tintColor: '#6BA461' }} />
        <Text style={[AppStyles.giftText]}> +1 Bonus!</Text>
      </View>
      {!self.state[`cartPressed_${item.ID}`] && (
        <TouchableOpacity
          style={[AppStyles.loginButtonStyles, { marginHorizontal: 8, width: width - 18, marginTop: 8 }]}
          onPress={() => {
            item.qty = qty;
            addItemsToBasket(this, item, item.ID, qty);
            self.setState({ [`cartPressed_${itemID}`]: true, itemsNo: self.state.itemsNo + 1, });
          }}
        >
          <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.add_to_cart}</Text>
        </TouchableOpacity>
      )}
      {self.state[`cartPressed_${item.ID}`] && (
        <View style={[AppStyles.loginButtonStyles, { marginHorizontal: 20, width: width - 18, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }]}>
          <TouchableOpacity
            onPress={() => {
              // Bounce animation on minus
              if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current) {
                self[`qtyAnimRef_${itemID}`].current.bounce(100);
              }
              self.setState(
                prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = (tempQty[itemID] || 1) - 1;
                  self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  if (self.state[`itemQty${itemID}`] <= 0) {
                    deleteItemsFromBasket(this, item, itemID);
                    return {
                      tempQty,
                      [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                      itemsNo: self.state.itemsNo - 1,
                    };
                  } else {
                    addItemsToBasket(this, item, item.ID, qty - 1);
                    return { tempQty };
                  }
                });
            }}
          >
            <Text style={{ color: '#FFF', fontFamily: AppStyles.fontFamily, fontSize: 25.263, fontStyle: 'normal', fontWeight: '700', lineHeight: 700 }}> - </Text>
          </TouchableOpacity>
          <Animatable.Text
            ref={self[`qtyAnimRef_${itemID}`]}
            style={{ color: '#FFF', fontFamily: AppStyles.fontFamily, fontSize: 16, fontStyle: 'normal', fontWeight: '700' }}>
            {qty || 1}
          </Animatable.Text>
          <TouchableOpacity
            onPress={() => {
              if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current) {
                self[`qtyAnimRef_${itemID}`].current.bounce(100);
              }
              self.setState(
                prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = (tempQty[itemID] || 1) + 1;
                  self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) + 1;
                  addItemsToBasket(this, item, item.ID, qty + 1);
                  return { tempQty };
                });
            }}
          >
            <Text style={{ color: '#FFF', fontFamily: AppStyles.fontFamily, fontSize: 25.263, fontStyle: 'normal', fontWeight: '700', lineHeight: 700 }}> + </Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  )
};

export const updateBasketItemsMap = async (items) => {
  const map = {};
  items.forEach(item => {
    map[item.ID] = item;
  });
  await saveToAS(Constants.ITEMS_MAP_IN_BASKET, JSON.stringify(map));
}

export const calculateOrderPrice = async () => {
  console.log('Calculating order price...');
  const parsedItems = await getBasketItems();
  try {
    const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
    await saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(orderResp.ITEMS));
    updateBasketItemsMap(orderResp.ITEMS);
    await saveToAS(Constants.BASKET_LAST_UPDATE, new Date().toISOString());
    return orderResp;
  } catch (e) {
    console.log('Failed to parse ITEMS_IN_BASKET:', e);
    console.log(parsedItems);
  }
};

export const getBasketLastUpdate = async () => {
  let lastUpdate = await getFromAS(Constants.BASKET_LAST_UPDATE);
  if (lastUpdate == null) return null;
  return new Date(lastUpdate);
}

export const updateProducts = async (self, products) => {
  await saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(products));
  updateBasketItemsMap(products);
}

export const addItemsToBasket = async (self, item, itemID, qty, callBack) => {
  const basketItems = await getBasketItems();
  console.log('Current basket items:', basketItems);
  const existingItem = basketItems.find(basketItem => basketItem.ID === itemID || basketItem.item?.ID === itemID);
  if (existingItem) {
    existingItem.qty = qty;
    // return;
  } else {
    basketItems.unshift(item);
  }
  await saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(basketItems));
  calculateOrderPrice(this).then(orderResp => {
    if (callBack) callBack(orderResp);
    if (self) {
      self.setState({ itemsNo: basketItems.length });
    }
    if (self.props.self) {
      self.props.self.setState({ itemsNo: basketItems.length });
    }
  });
  return basketItems;
};

export const deleteItemsFromBasket = async (self, item, itemID, callBack) => {
  item.qty = 0;
  const basketItems = await getBasketItems();
  const index = basketItems.findIndex(basketItem => basketItem.ID === item.ID);
  console.log('Deleting item from basket:', itemID);
  console.log('index:', index, 'item.ID:', item.ID);
  console.log('basketItems before deletion:', basketItems);
  if (index !== -1) {
    basketItems.splice(index, 1);
    console.log('basketItems after deletion:', basketItems);
    await saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(basketItems));
    calculateOrderPrice(this).then(orderResp => {
      if (callBack) callBack(orderResp);

      if (self) {
        self.setState({ itemsNo: basketItems.length });
      }
      if (self.props.self) {
        self.props.self.setState({ itemsNo: basketItems.length });
      }

    });
  }
};

export const deleteAllItemsInBasket = async () => {
  await saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify([]));
  // await saveToAS(Constants.BASKET_LAST_UPDATE, new Date().toISOString());
  // await saveToAS(Constants.ITEMS_MAP_IN_BASKET, JSON.stringify({}));
};



export const searchAddingItems = (self, item, itemID, onUpdate) => {
  // let qty = self.state.tempQty && self.state.tempQty[item.ID] ? self.state.tempQty[item.ID] : 1;
  let qty = self.state[`itemQty${itemID}`] && self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`] : 1;


  if (self.state[`cartPressed_${item.ID}`] === undefined) {
    self.state[`cartPressed_${item.ID}`] = checkItemIsInBasket(self, item.ID).inBasket;
  }
  if (!self.state[`cartPressed_${item.ID}`]) {
    return (
      <View>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={async () => {
            item.qty = qty;
            self.setState({ [`cartPressed_${itemID}`]: true, itemsNo: self.state.itemsNo + 1, });
            await addItemsToBasket(this, item, item.ID, qty);
            self.setState(
              prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = (tempQty[itemID] || 1);
                self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1);
                return { tempQty };
              });
            onUpdate();
          }}
          style={{ width: 36, height: 36, alignItems: 'center', justifyContent: 'center', zIndex: 3 }}>
          <Image source={circlePlus} style={{ width: 24.972, height: 24.972 }} />
        </TouchableOpacity>
      </View>
    );
  }

  // Create a ref for the Animatable.Text if not already created
  if (!self[`qtyAnimRef_${itemID}`]) self[`qtyAnimRef_${itemID}`] = React.createRef();

  return (
    <View style={{ justifyContent: 'center', alignItems: 'center', marginEnd: 5 }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: 4, }}>
        {/* <Image source={giftIcon} style={{ width: 12.016, height: 12.084, tintColor: '#6BA461' }} />
        <Text style={[AppStyles.giftText]}> + {item.BONUS}</Text> */}
      </View>
      <View
        style={{
          flexDirection: 'row', gap: qty > 99 ? 5 : 10, padding: 4, paddingHorizontal: 8,
          alignItems: 'center', backgroundColor: '#6BA461', borderRadius: 20, justifyContent: 'space-between', zIndex: 3
        }}>
        <TouchableOpacity style={{ zIndex: 3, width: 12, height: 12, alignItems: 'center', justifyContent: 'center' }}
          onPress={async () => {
            await addItemsToBasket(this, item, item.ID, self.state[`itemQty${itemID}`] - 1);
            self.setState(prevState => {
              const tempQty = { ...(prevState.tempQty || {}) };
              tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
              // If qty is now <= 0, toggle cartPressed state
              self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
              if (self.state[`itemQty${itemID}`] <= 0) {
                deleteItemsFromBasket(this, item, itemID);
                return {
                  tempQty,
                  [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                  itemsNo: self.state.itemsNo - 1,
                };
              } else {
                //  addItemsToBasket(this, item, item.ID, qty - 1);
                return { tempQty, };
              }
            });
            onUpdate();
          }}>
          <Image source={minus} style={{ width: 9.965, height: 2, tintColor: '#FFF' }} />
        </TouchableOpacity>
        <View style={{ zIndex: 3, width: qty > 99 ? 26 : qty > 9 ? 18 : 12 }}>
          <TextInput
            ref={self[`qtyAnimRef_${itemID}`]}
            style={[
              AppStyles.featuredItemsQtyStyle,
              { textAlign: 'center', padding: 0, margin: 0, backgroundColor: 'transparent' }
            ]}
            // value={qty.toString()}
            keyboardType={"number-pad"}
            selectTextOnFocus={true}
            value={self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`].toString() : 1}
            onFocus={() => {
              // When first pressing, clear the text
              self.setState({ [`itemQty${itemID}`]: self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`] : 1 });
            }}
            onChangeText={async (text) => {
              // Only allow numbers
              let newQty = parseInt(text.replace(/[^0-9]/g, ''), 10);
              if (isNaN(newQty) || newQty < 1) {
                // newQty = 1;
                await deleteItemsFromBasket(this, item, itemID);
                self.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                    [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                    itemsNo: self.state.itemsNo - 1,
                  };
                });
              }
              // Animate on change
              if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current && self[`qtyAnimRef_${itemID}`].current.bounce) {
                self[`qtyAnimRef_${itemID}`].current.bounce(100);
              }
              self.state[`itemQty${itemID}`] = newQty;
              await addItemsToBasket(this, item, item.ID, newQty);
              self.setState(prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = newQty;
                return { tempQty };
              });
              onUpdate();
            }}
          />
        </View>
        <TouchableOpacity style={{ width: 12, height: 12, }}
          onPress={async () => {
            self.setState(async prevState => {
              const tempQty = { ...(prevState.tempQty || {}) };
              tempQty[itemID] = (tempQty[itemID] || 1) + 1;
              self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) + 1;
              return { tempQty };
            });
            await addItemsToBasket(this, '', item.ID, qty + 1);
            onUpdate();

          }}>
          <Image source={plus} style={{ width: 10, height: 10, tintColor: '#FFF' }} />
        </TouchableOpacity>
      </View>
    </View >
  );
};

// export const updateCurrentProduct = async (self, productID) => {
//     const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
//     try {
//       const parsedItems = JSON.parse(itemsInBasket);
//       const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
//       console.log(parsedItems);
//       console.log(orderResp.ITEMS);
//       if (orderResp && Array.isArray(orderResp.ITEMS)) {
//         const foundItem = orderResp.ITEMS.find(item => item.ID === productID);
//         if (foundItem) {
//           self.setState({ updatedItem: foundItem });
//           console.log('Found product:', foundItem);
//         } else {
//           console.log('Product not found in ITEMS');
//         }
//       }
//     } catch (e) {
//       console.log('Failed to parse ITEMS_IN_BASKET:', e);
//       console.log(itemsInBasket);
//     }

//   };




export const checkItemIsInBasket = async (self, itemID) => {
  const inBasketItems = await getBasketItems();
  const inBasket = inBasketItems.some(inBasketItems => inBasketItems.ID === itemID || inBasketItems.item?.ID === itemID);
  self.state[`cartPressed_${itemID}`] = inBasket;
  const item = inBasketItems.find(i => (i.ID === itemID || i.item?.ID === itemID)) || {};
  self.state[`itemQty${itemID}`] = item.qty || 0;
  return { inBasket, qty: item.qty || 0, item: item.ID ? item : undefined };
};

export const updateItemsNo = async (self, action, qty) => {
  const parsedItems = await getBasketItems();
  try {
    let itemsNo = parsedItems.length;

    if (action === 'add') {
      itemsNo += qty || 1;
    } else if (action === 'decrease') {
      itemsNo -= qty || 1;
    }
    if (itemsNo < 0) itemsNo = 0;
    console.log('Parsed ITEMS_IN_BASKET:', itemsNo);
    if (action === "") {
      return itemsNo;
    }

    return itemsNo;
  } catch (e) {
    console.log('Failed to parse ITEMS_IN_BASKET:', e);
  }
};




export const addingItems = (self, item, itemID, onUpdate,) => {
  // let qty = self.state.tempQty && self.state.tempQty[item.ID] ? self.state.tempQty[item.ID] : 1;
  let qty = self.state[`itemQty${itemID}`] && self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`] : 1;


  if (self.state[`cartPressed_${item.ID}`] === undefined) {
    self.state[`cartPressed_${item.ID}`] = checkItemIsInBasket(self, item.ID).inBasket;
  }

  if (!self.state[`cartPressed_${item.ID}`]) {
    return (
      <TouchableOpacity style={{
        padding: 20,
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        right: 0,
        top: width / 2 - 90,
        zIndex: 4
      }} onPress={async () => {
        item.qty = qty;
        await addItemsToBasket(this, item, item.ID, 1);
        await self.setState({ [`cartPressed_${itemID}`]: true, itemsNo: self.state.itemsNo + 1, });
        self.setState(
          prevState => {
            const tempQty = { ...(prevState.tempQty || {}) };
            tempQty[itemID] = (tempQty[itemID] || 1);
            self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1);
            return { tempQty };
          });
        onUpdate();
      }}>
        <Image source={circlePlus} style={{ width: 24.972, height: 24.972 }} />
      </TouchableOpacity>
    );
  }
  // Create a ref for the Animatable.Text
  if (!self[`qtyAnimRef_${itemID}`]) self[`qtyAnimRef_${itemID}`] = React.createRef();

  return (
    <TouchableOpacity style={{ padding: 20, position: 'absolute', right: 0, top: width / 2 - 95, zIndex: 2 }}>
      <ImageBackground source={imgGreenVector} style={{
        width: 78, height: 31, flexDirection: 'row', gap: 10,
        alignItems: 'center', justifyContent: 'center',
      }} >
        <TouchableOpacity
          style={{ zIndex: 3, width: 12, height: 10, alignItems: 'center', justifyContent: 'center', marginLeft: 5 }}
          onPress={async () => {
            // if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current) {
            //   self[`qtyAnimRef_${itemID}`].current.bounce(100);
            // }
            self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
            if (self.state[`itemQty${itemID}`] <= 0) {
              await deleteItemsFromBasket(this, item, itemID);
              self.setState(prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                return {
                  tempQty,
                  [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                  itemsNo: self.state.itemsNo - 1,
                };
              });
            } else {
              await addItemsToBasket(this, item, item.ID, qty - 1);
              self.setState(prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                return {
                  tempQty,
                };
              });
            }
            onUpdate();
          }}>
          <Image source={minus} style={{ width: 12, height: 1.5, marginRight: 5, tintColor: '#FFF' }} />
        </TouchableOpacity>
        <View style={{ zIndex: 3, width: qty > 99 ? 26 : qty > 9 ? 18 : 12 }}>
          <TextInput
            ref={self[`qtyAnimRef_${itemID}`]}
            style={[
              AppStyles.featuredItemsQtyStyle,
              { textAlign: 'center', padding: 0, margin: 0, backgroundColor: 'transparent' }
            ]}
            // value={qty.toString()}
            keyboardType={"number-pad"}
            selectTextOnFocus={true}
            value={self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`].toString() : 1}
            onFocus={() => {
              // When first pressing, clear the text
              self.setState({ [`itemQty${itemID}`]: self.state[`itemQty${itemID}`] ? self.state[`itemQty${itemID}`] : 1 });
            }}
            onChangeText={async (text) => {
              // Only allow numbers
              let newQty = parseInt(text.replace(/[^0-9]/g, ''), 10);
              if (isNaN(newQty) || newQty < 1) {
                // newQty = 1;
                await deleteItemsFromBasket(this, item, itemID);
                self.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                    [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                    itemsNo: self.state.itemsNo - 1,
                  };
                });
              }
              // Animate on change
              if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current && self[`qtyAnimRef_${itemID}`].current.bounce) {
                self[`qtyAnimRef_${itemID}`].current.bounce(100);
              }
              self.state[`itemQty${itemID}`] = newQty;
              await addItemsToBasket(this, item, item.ID, newQty);
              self.setState(prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = newQty;
                return { tempQty };
              });
              onUpdate();
            }}
          />
        </View>
        <TouchableOpacity
          style={{ zIndex: 3, width: 12, height: 12 }}
          onPress={async () => {
            // if (self[`qtyAnimRef_${itemID}`] && self[`qtyAnimRef_${itemID}`].current) {
            //   self[`qtyAnimRef_${itemID}`].current.bounce(100);
            // }
            self.setState(
              prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = (tempQty[itemID] || 1) + 1;
                self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) + 1;
                return { tempQty };
              });
            await addItemsToBasket(this, item, item.ID, qty + 1);
            onUpdate();
          }}>
          <Image source={plus} style={{ width: 12, height: 12, tintColor: '#FFF' }} />
        </TouchableOpacity>
      </ImageBackground>
    </TouchableOpacity>
  );
};


export const renderSearchView = (self) => {
  if (!self.isMobile) {
    width = Dimensions.get("window").width - Constants.SIDEBAR_WIDTH;
  }
  return (
    <FlatList
      style={{ height }}
      removeClippedSubviews
      maxToRenderPerBatch={10}
      windowSize={10}
      data={self.state.products}
      keyExtractor={(item, index) => item.id?.toString() || index.toString()}
      showsVerticalScrollIndicator={false}

      renderItem={({ item }) => {
        return (
          <View style={{
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            marginVertical: 10,
            position: 'relative'
          }}>
            <TouchableOpacity
              activeOpacity={0.7}
              style={{ flexDirection: 'row', gap: 8 }}
              onPress={() => self.setState({ showProductsDetails: true, productID: item.ID })}
            >
              <Image
                source={item.IMG}
                style={{ width: 89.974, height: 70.772, borderRadius: 8 }}
                resizeMode="cover"
              />
              <View style={{ justifyContent: "space-around", width: width - 130 }}>
                <Text style={[AppStyles.OrderNowDescStyle, { flexGrow: 1, width: width - 150 }]} >{item.NAME}</Text>
                <Text style={[AppStyles.orderNowPriceStyle, { marginBottom: 4 }]}>{item.PUBLIC_PRICE} JOD</Text>
              </View>
            </TouchableOpacity>
            {/* {Commons.searchAddingItems(this, item, item.ID, '', this.state.itemsNo, '')} */}

            <View style={{ position: 'absolute', bottom: 15, right: 10, width: 55.857, height: 23, zIndex: 10, alignItems: 'flex-end' }}>
              {searchAddingItems(self, item, item.ID, '')}
            </View>




            {self.state.orderResponse && (
              (() => {
                const existed = self.state.orderResponse.find(existed => existed.ID === item.ID);
                if (existed) {
                  if (existed.BONUS !== '' && existed.NEXT_BONUS > 0 && existed.NEXT_BONUS_TEXT !== '') {
                    return (
                      <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Text style={[AppStyles.bonusSearchText]}>
                          Bonus {existed.NEXT_BONUS_TEXT}
                        </Text>
                      </View>
                    );
                  }
                  if (existed.NEXT_BONUS_TEXT === '' && existed.BONUS !== '') {
                    return (
                      <View style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        backgroundColor: '#6BA461',
                        borderTopLeftRadius: 5,
                        borderBottomRightRadius: 5,
                        paddingVertical: 2,
                        zIndex: 10,
                        width: 55.857,
                        height: 23,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'row',
                        gap: 2.5,
                      }}>
                        <Image source={giftIcon} style={{ height: 10, width: 10 }}></Image>
                        <Text style={[AppStyles.bonusSearchText]}>+ {existed.BONUS}</Text>
                      </View>
                    )
                  }

                } else {
                  if (item.NEXT_BONUS_TEXT !== '') {
                    return (
                      <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                        <Text style={[AppStyles.bonusSearchText]}>
                          Bonus {item.NEXT_BONUS_TEXT}
                        </Text>
                      </View>
                    );
                  }

                }

              })()
            )}

            {self.state.updatedItem && Object.keys(self.state.updatedItem).length > 0 && self.state.updatedItem.ID === item.ID && (
              (() => {
                if (self.state.updatedItem.NEXT_BONUS_TEXT !== '' && self.state.updatedItem.BONUS !== '' && self.state.updatedItem.NEXT_BONUS > 0) {
                  return (
                    <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                      <Text style={[AppStyles.bonusSearchText]}>
                        Bonus {self.state.updatedItem.NEXT_BONUS_TEXT}
                      </Text>
                    </View>
                  )
                }

                if (self.state.updatedItem.NEXT_BONUS_TEXT === '' && self.state.updatedItem.BONUS !== '') {
                  return (
                    <View style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      backgroundColor: '#6BA461',
                      borderTopLeftRadius: 5,
                      borderBottomRightRadius: 5,
                      paddingVertical: 2,
                      zIndex: 10,
                      width: 55.857,
                      height: 23,
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'row',
                      gap: 2.5,
                    }}>
                      <Image source={giftIcon} style={{ height: 10, width: 10 }}></Image>
                      <Text style={[AppStyles.bonusSearchText]}>+ {self.state.updatedItem.BONUS}</Text>
                    </View>
                  )
                }
                self.setState({ updatedItem: [] });

              })()
            )}


          </View>
        )
      }
      }
      contentContainerStyle={{ paddingVertical: 8, alignItems: 'center', justifyContent: 'center' }}
      numColumns={1}
    />
  )
}

export const renderSearchItems = () => {
  return (
    <View style={{ width, height, backgroundColor: 'blue' }}>

    </View>
  )
}


export const renderAppHeader = (style, self, switchToOrderNow, products, productsBackup, isSearch, searched, searchText, itemsNo, notifications = []) => {
  // Add a ref to the badge view
  const xisMobile = isMobile();
  if (!xisMobile) {
    width = getDesktopWidth();
  }
  if (!self.cartBadgeRef) self.cartBadgeRef = React.createRef();

  // Helper to animate the badge
  self.animateCartBadge = () => {
    if (self.cartBadgeRef && self.cartBadgeRef.current && self.cartBadgeRef.current.animate) {
      self.cartBadgeRef.current.animate('swing', 500);
    }
  };

  // Detect itemsNo increase and animate badge
  if (typeof self.prevItemsNo === "undefined") self.prevItemsNo = itemsNo;
  if (itemsNo > self.prevItemsNo) {
    setTimeout(() => self.animateCartBadge && self.animateCartBadge(), 0);
  }
  self.prevItemsNo = itemsNo;


  // Only show search bar if not on OrderNow screen
  if (self.props.route?.name === "OrderNow") {
    return null;
  }


  self.search = async (text) => {
    if (switchToOrderNow) {
      self.setState({ showOrderNow: true, searchText: text });
      return;
    }
    try {
      if (text.includes(String.fromCharCode(29))) {
        text = processBarcode(text)["01"];
      }
    } catch (error) {
      console.error("Error processing barcode:", error);
    }

    self.setState({ searchText: text, showCloseIcon: true, borderWidth: 0.5, borderColor: '#3B627F', isSearch: true, });
    if (text.length <= 0) {
      self.setState({ showCloseIcon: false, borderWidth: 0, borderColor: '', isSearch: false, searched: false, });
    }
    // Ensure productsBackup is initialized with the original products
    if (!self.state.productsBackup && products && products.length > 0) {
      self.setState({ productsBackup: products });
    }


    const backup = self.state.productsBackup || productsBackup || products;
    if (text.length >= 1) {
      const filtered = backup
        ? backup.filter(item => {
          const nameMatch = item.NAME && item.NAME.toLowerCase().includes(text.toLowerCase());
          const barcodeMatch = item.BARCODE && (item.BARCODE.toLowerCase().includes(text.toLowerCase()) || (text.toLowerCase().includes(item.BARCODE) && item.BARCODE.length > 3));
          const priceMatch = item.PUBLIC_PRICE && item.PUBLIC_PRICE.includes(text);
          const categMatch = (item.CATEG_EN_NAME && item.CATEG_EN_NAME.toLowerCase().includes(text)) || (item.CATEG_AR_NAME && item.CATEG_AR_NAME.toLowerCase().includes(text));
          const brandMatch = (item.BRAND_EN_NAME && item.BRAND_EN_NAME.toLowerCase().includes(text)) || (item.BRAND_AR_NAME && item.BRAND_AR_NAME.toLowerCase().includes(text));
          // Add more fields as needed
          return nameMatch || barcodeMatch || priceMatch || categMatch || brandMatch;
        })
        : [];
      self.setState({ products: filtered, isSearch: true });
    } else {
      // Restore original products
      self.setState({ products: backup, isSearch: false });
    }
  };
  return (
    // <View>
    [
      <View style={{
        position: 'absolute',
        top: 72 + (self.title == 'Order Now' || self.title == 'filters' ? 40 : 0),
        left: 0,
        right: 0,
        height: 15,
        background: 'linear-gradient(rgba(249, 253, 254, .9), transparent)',
        pointerEvents: 'none',
        zIndex: 1
      }} />
      , <View style={{
        flexDirection: 'row',
        alignItems: 'center', padding: 16, alignSelf: "stretch",
        justifyContent: "center",
        backgroundColor: xisMobile ? undefined : AppStyles.desktopBackgroundColor,
      }}>
        <View style={{
          flexDirection: 'row', alignItems: 'center', flex: 1,
          backgroundColor: '#fff', borderRadius: 10,
          justifyContent: 'center', borderWidth: self.state.borderWidth, borderColor: self.state.borderColor
        }}>
          <Image source={imgSearchIcon} style={{ width: 21, height: 21, marginLeft: 13, tintColor: '#3d3d3dff' }} />
          <TextInput
            autoFocus={!xisMobile}
            ref={r => self.searchInputRef = r}
            style={[{
              flex: 1,
              height: 40,
              fontSize: 14,
              color: Styles.appColor1,
              backgroundColor: '#fff',
              borderRadius: 10,
              borderWidth: 0,
              lineHeight: 1.35 * 14,
              marginLeft: 8,
              outlineStyle: 'none',
              fontWeight: '400',
              fontFamily: AppStyles.fontFamily
            }]}
            placeholder={xisMobile ? "Search by name, barcode, ingredient..." : "Start adding to your cart → search by product name, barcode number...."}
            placeholderTextColor='rgba(59, 98, 127, 0.50)'
            value={self.state.searchText}
            onSubmitEditing={() => self.setState({ searched: true, searchText })}
            search={(text) => { self.setState({ searchText: text }) }}
            onChangeText={async (text) => {
              self.search(text);
            }}
          />
          {xisMobile && (
            <TouchableOpacity onPress={() => handleQRCodeScan(self)}>
              <Image source={cameraImg} style={{ width: 15.342, height: 14, tintColor: Styles.appColor1, marginRight: 13 }} />
            </TouchableOpacity>
          )}
          {self.state.showCloseIcon && (
            <TouchableOpacity
              style={{ marginRight: 13 }}
              onPress={() => self.setState({ showCloseIcon: false, searchText: "", products: self.state.productsBackup, isSearch: false, searched: false })}>
              <Image source={SearchCloseIcon} style={{ width: 8, height: 8, tintColor: Styles.appColor1 }} resizeMode="contain" />
            </TouchableOpacity>
          )}
        </View>
        {!xisMobile &&
          <TouchableOpacity style={{ marginLeft: 10 }}
            onPress={() => {
              self.setState({ showNotifications: true });
              if (self.props.self) {
                self.props.self.setState({ showNotifications: true });
              }
            }}>
            <Animatable.Image
              ref={self.notificationRef}
              source={notifyImg}
              style={{ width: 21.203, height: 21, tintColor: Styles.appColor1 }}
              resizeMode="contain"
            />
            {notifications && (
              <Animatable.View
                style={{
                  position: 'absolute',
                  top: 2,
                  right: 0,
                  width: 9,
                  height: 9,
                  borderRadius: 12,
                  backgroundColor: '#FF0000',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1
                }}>
              </Animatable.View>
            )}
          </TouchableOpacity>
        }
        {xisMobile && (
          <TouchableOpacity style={{ marginLeft: 10 }}
            onPress={() => {
              if (!isMobile()) {
                self.checkout();
                return;
              }

              if (self.props.navigation) {
                self.props.navigation.navigate("checkout");
              } else {
                alert('Navigating to checkout');
                window.location = './checkout';
              }
              if (typeof window !== 'undefined' && window.location.pathname) {
                window.history.pushState({
                  page: 'checkout',
                }, 'checkout', window.location.pathname);
              }
            }}>
            <Animatable.Image
              ref={self.cartBadgeRef}
              source={cartIcon}
              style={{ width: 20.203, height: 20, tintColor: Styles.appColor1 }}
              resizeMode="contain"
            />
            {itemsNo > 0 && (
              <Animatable.View
                style={{
                  position: 'absolute',
                  top: -8,
                  right: -8,
                  width: 15,
                  height: 15,
                  borderRadius: 12,
                  backgroundColor: Styles.appColor1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1
                }}>
                <Text style={{ color: 'white', fontWeight: '700', fontSize: 8 }}>{self.state.itemsNo}</Text>
              </Animatable.View>
            )}
          </TouchableOpacity>
        )}
      </View>
    ]

    // </View>
  )
};


export const renderOtherView = (self) => {
  const otherTitles = [
    { title: STRINGS.Statement_of_Account_Desktop, onPress: () => window.location = './StatementOfAccount', sources: SOAimg, },
    { title: STRINGS.Invoice_Returns_Desktop, onPress: () => window.location = './InvoicesReturns', sources: IRimg, },
    { title: STRINGS.app_notifications, onPress: () => window.location = './appNotifications', sources: notificationImg, },
    { title: STRINGS.profile_Desktop, onPress: () => window.location = './profile', sources: imgProfile, },
  ];
  return (
    <Animatable.View
      animation="slideInUp"
      duration={400}
      style={{
        position: 'absolute',
        bottom: 70,
        left: 0,
        right: 0,
        zIndex: 1000,
        width: width,
        height: height - 50,
        justifyContent: 'flex-end',
        pointerEvents: 'box-none',
      }}
      pointerEvents="box-none"
    >
      <TouchableOpacity
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255,255,255,0.5)',
          zIndex: 1000,
        }}
        onPress={() => self.setState({ isOther: false })}
      />
      {/* Content */}
      <View
        style={{
          width: width - 12,
          backgroundColor: AppStyles.desktopBackgroundColor,
          height: height / 2.3,
          minHeight: 350,
          zIndex: 1010,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          opacity: 1,
          paddingVertical: 16,
          alignSelf: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'visible', // allow overflow
          flexDirection: 'column',
        }}
        pointerEvents="box-none"
      >
        <View style={{ marginBottom: 10, backgroundColor: AppStyles.desktopBackgroundColor, flexDirection: 'column', width }}>
          <Text style={[AppStyles.otherTabTitle, { alignSelf: 'center' }]}>{STRINGS.app_Other}</Text>
          {otherTitles.map((item, idx) => (
            <TouchableOpacity
              key={idx}
              style={{
                display: 'flex',
                width: width - 80,
                height: 55,
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 16,
                flexDirection: 'row',
                borderRadius: 10.793,
                backgroundColor: '#FFF',
                boxShadow: '0px 1.799px 6.296px 0px rgba(0, 0, 0, 0.08)',
                marginLeft: 'auto',
                marginRight: 'auto',
                bottom: 5,
                marginTop: idx === 0 ? 30 : 10,
              }}
              onPress={() => { item.onPress() }}
            >
              <Image source={item.sources} style={{ width: 28.783, height: 28.783, marginHorizontal: 14, tintColor: '#9197b3' }} />
              <Text style={[AppStyles.checkOutPaymentTerms, { color: Styles.appColor1 }]}>{item.title}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </Animatable.View>
  )
}

export const renderAppFooter = (style, self, homeTint, orderTint, accountTint, otherTint) => {
  const footerTitles = [
    {
      title: STRINGS.app_Home, onPress: () => {
        if (self.props.navigation) {
          self.props.navigation.navigate("shop");
        } else {
          window.location = './shop';
        }
        if (typeof window !== 'undefined' && window.location.pathname) {
          window.history.pushState({
            page: 'Shop',
          }, 'Shop', window.location.pathname);
        }
      }, sources: imgHomeGreyFooter, tintColor: homeTint || Styles.appColor1
    },
    {
      title: STRINGS.app_Order_Now, onPress: () => {
        if (self.props.navigation) {
          self.props.navigation.navigate("orderNow");
        } else {
          window.location = './orderNow';
        }
        if (typeof window !== 'undefined' && window.location.pathname) {
          window.history.pushState({
            page: 'OrderNow',
          }, 'OrderNow', window.location.pathname);
        }
      }, sources: imgOrderNow, tintColor: orderTint || Styles.appColor1
    },
    {
      title: STRINGS.Orders, onPress: () => {
        if (self.props.navigation) {
          self.props.navigation.navigate("myorders");
        } else {
          window.location = './myorders';
        }
        if (typeof window !== 'undefined' && window.location.pathname) {
          window.history.pushState({
            page: 'MyOrders',
          }, 'MyOrders', window.location.pathname);
        }
      }, sources: myorders, tintColor: accountTint || Styles.appColor1
    },
    { title: STRINGS.app_Other, onPress: () => { self.setState({ isOther: !self.state.isOther }); }, sources: otherIcon, tintColor: otherTint },
  ];
  return (
    [
      <View style={{
        position: 'absolute',
        bottom: 82,
        left: 0,
        right: 0,
        height: 40,
        background: 'linear-gradient(transparent, rgba(249, 253, 254, 1))',
        pointerEvents: 'none',
        zIndex: 1
      }} />
      ,
      <View style={{ flexDirection: "row", justifyContent: "space-around", width, marginBottom: 20, backgroundColor: AppStyles.desktopBackgroundColor }}>
        {footerTitles.map((footer, index) => {
          return (
            <TouchableOpacity
              key={index}
              onPress={() => {
                self.setState({ pressedFooterIndex: index });
                footer.onPress();
              }}
              style={{ marginTop: 20, justifyContent: "center", alignItems: "center" }}
            >
              <Image
                source={footer.sources}
                style={{
                  height: 25,
                  width: 24,
                  tintColor: footer.tintColor,
                }}
                resizeMode="contain"
              />
              <Text style={[
                AppStyles.appFooterTextStyle,
                { color: footer.tintColor }
              ]}>
                {footer.title}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    ]
  );
};

export const renderFooter = (style, self) => {
  const isMobile = width <= Constants.MOBILE_WIDTH;
  if (isMobile) return footerFooterMobile(style, self);

  return (
    <View
      style={[{
        width: self.props.width,
        paddingTop: 42.879,
        paddingBottom: 13.5,
        paddingHorizontal: 34,
        marginTop: 20,
      }, style]}
    >

      <View
        style={[{
          height: 30.5,
          width: self.props.width,
          flexDirection: "row",
          justifyContent: 'space-between',
          marginTop: 100,
          flexDirection: "row"
        }]}
      >
        <Text style={[Styles.TextStyle2, { fontSize: 12 }]}>Copyright ©2023 Jordan Drugstore Co. All Rights Reserved.</Text>
        <View style={{ flexDirection: "row", gap: 37.692 }}>
          {renderFooterItem(self, 'Privacy')}
          {renderFooterItem(self, 'Terms and conditions')}
          {renderFooterItem(self, 'Contact Us', () => window.location = './contactus')}
          {renderFooterItem(self, 'Careers', () => window.location = './careers')}
        </View>
        <View></View>
        <View style={{ flexDirection: "row", width: 103.277, justifyContent: "space-between" }}>
          {renderFooterImage(self, 'facebook', faceBookIcon, faceBookHoveredIcon, () => Linking.openURL("https://www.facebook.com/jordandrugstoreco/?_rdr"))}
          {renderFooterImage(self, 'linkedin', linkedinIcon, linkedinHoveredIcon, () => Linking.openURL("https://www.linkedin.com/company/jordan-drugstore-co/?viewAsMember=true"))}
          {renderFooterImage(self, 'instagram', instagramIcon, instagramHoveredIcon, () => Linking.openURL("https://www.instagram.com/jordandrugstoreco/?hl=en"))}
        </View>
      </View>
    </View >);
}

const renderFooterItem = (self, text, onPress) => {
  if (!self.FooterItems) self.FooterItems = {};
  return (
    <Pressable
      ref={el => (self.FooterItems[text] = el)}
      onHoverIn={() => self.setState({ hoveredComponent: self.FooterItems[text] })}
      onHoverOut={() => self.setState({ hoveredComponent: undefined })}>
      <TouchableOpacity onPress={onPress}>
        <Text style={self.state.hoveredComponent && self.FooterItems[text]
          == self.state.hoveredComponent ? Styles.FooterTextStyleHovered : Styles.FooterTextStyle}>
          {text}
        </Text>
      </TouchableOpacity>
    </Pressable>
  )
}

const renderFooterItemMobile = (self, text, onPress, textStyle) => {
  if (!self.FooterItems) self.FooterItems = {};
  return (
    <Pressable
      ref={el => (self.FooterItems[text] = el)}>
      <TouchableOpacity onPress={onPress}>
        <Text style={[{ ...Styles.TextStyle2, fontSize: 16, letterSpacing: 0.8, fontWeight: '400', paddingVertical: 2 }, textStyle]}>
          {text}
        </Text>
      </TouchableOpacity>
    </Pressable>
  )
}

const renderFooterImage = (self, text, source, hoveredSoruce, onPress) => {
  if (!self.FooterItems) self.FooterItems = {};
  return (
    <Pressable
      ref={el => (self.FooterItems[text] = el)}
      onHoverIn={() => self.setState({ hoveredComponent: self.FooterItems[text] })}
      onHoverOut={() => self.setState({ hoveredComponent: undefined })} >
      <TouchableOpacity onPress={onPress}>
        <Image source={self.state.hoveredComponent && self.FooterItems[text]
          == self.state.hoveredComponent ? hoveredSoruce : source}
          style={[{ width: 26.94, height: 26.94, marginTop: -13 }]} />
      </TouchableOpacity>
    </Pressable>
  )
}

const renderFooterImageMobile = (self, text, source, hoveredSoruce, onPress) => {
  if (!self.FooterItems) self.FooterItems = {};
  return (
    <Pressable
      ref={el => (self.FooterItems[text] = el)}
      onHoverIn={() => self.setState({ hoveredComponent: self.FooterItems[text] })}
      onHoverOut={() => self.setState({ hoveredComponent: undefined })} >
      <TouchableOpacity onPress={onPress}>
        <Image source={hoveredSoruce}
          style={[{ width: 26.94, height: 26.94, marginTop: -13 }]} />
      </TouchableOpacity>
    </Pressable>
  )
}

export const resizeHandle = (window, self, fn) => {
  // console.log('Resize detected', self.title);
  window.onresize = () => {
    setTimeout(() => {
      self.width = getWidth();
      self.height = Dimensions.get("window").height;
      if (fn) fn();
      self.setState({});
    }, 100);
  };
}

export const getTextWidth = (text) => {
  // Check if we're in a web environment
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    // Not in web environment, use alternative calculation method for React Native
    // For React Native, we can estimate text width using font size and character count
    // This is an approximation since we don't have canvas API
    const fontSize = 12; // Default font size
    const avgCharWidth = fontSize * 0.6; // Approximate character width ratio
    return text.length * avgCharWidth;
  }
  // Create a temporary canvas element
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  // Set the font to the context
  context.font = '14.2px Satoshi-Regular'; // You can customize the font size and family here
  // Measure the text width
  const metrics = context.measureText(text);
  return metrics.width;
}

export const getMenuScale = () => {
  width = Dimensions.get("window").width;
  const orgWidth = 378;
  let menuWidth = orgWidth;
  if (width < 1400) {
    menuWidth -= (1400 - width);
  }
  if (menuWidth > orgWidth) {
    menuWidth = orgWidth;
  }
  if (menuWidth < 280) {
    menuWidth = 280;
  }
  return menuWidth / orgWidth;
}

const barcodeMap = {
  "01": "14", // GTIN
  "11": "6", // Prod dt
  "17": "6", // Exp. dt
  "10": "variable", // Batch
  "21": "variable" // SN
};
export const processBarcode = (barcode) => {
  const resultMap = {};
  try {
    // String.fromCharCode(29)
    const strList = barcode.replace(String.fromCharCode(29), " ").split(" ");
    strList.map(str => {
      processStr(str, resultMap)
    });
  } catch (err) {
    console.log(err);
  }
  return resultMap;
}

export const processStr = (str, resultMap) => {
  try {
    const code = str.substring(0, 2);
    // console.log(code);
    const valLen = barcodeMap[code];
    const val = valLen == "variable" || valLen == undefined ? str.substring(2) : str.substring(2, parseInt(valLen) + 2);
    resultMap[code] = val;
    if (str.length > 2 + val.length) {
      processStr(str.substring(2 + val.length), resultMap);
    }
  } catch (err) {
    // alert(err);
  }
}
